<template>
  <div class="project">
    <!-- programeaza o intalnire cta -->
    <div class="appointment-cta">
      <a
        href="#"
        @click.prevent="AppointmentForm(true)"
        @keydown.esc="AppointmentForm(false)"
        >{{ strings.programeaza_intalnire_cta }}
      </a>
    </div>

    <!-- programeaza o intalnire form -->
    <div class="appointment-form">
      <div class="appointment-form-shape mask-right">
        <div class="appointment-form-col">
          <a href="#" @click.prevent="AppointmentForm(false)">
            <svg
              width="47"
              height="44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke="#000"
                stroke-width="2"
                d="M2.6976 1.2835l43.0645 41.9334M44.3669 1.2835L1.3024 43.217"
              />
            </svg>
          </a>
        </div>
        <div class="appointment-form-col">
          <h5>{{ strings.programeaza_intalnire_headline }}</h5>
          <form
            class="form-styles form-styles--dark form-styles--w70"
            @submit="submitForm"
            action="#"
            method="post"
          >
            <input
              type="hidden"
              id="form_type"
              name="form_type"
              value="meeting"
            />
            <input
              type="text"
              name="user_name"
              v-model="user_name"
              value=""
              :placeholder="strings.programeaza_intalnire_nume"
              required
            />
            <input
              type="email"
              name="user_email"
              v-model="user_email"
              value=""
              :placeholder="strings.programeaza_intalnire_email"
              required
            />
            <input
              type="tel"
              name="user_phone"
              pattern="[0-9]{4}[0-9]{3}[0-9]{3}"
              v-model="user_phone"
              value=""
              :placeholder="strings.programeaza_intalnire_tel"
              required
            />
            <input
              type="date"
              id="date"
              name="user_date"
              v-model="user_date"
              value=""
              min="2020-06-01"
              max="2030-12-31"
            />
            <textarea
              name="user_message"
              rows="8"
              cols="80"
              v-model="user_message"
              :placeholder="strings.programeaza_intalnire_mesaj"
              required
            ></textarea>
            <!-- newsletter -->
            <div class="gdpr_wrapper gdpr_wrapper--black">
              <input
                type="checkbox"
                id="subscribe_newsletter"
                name="subscribe_newsletter"
                value="true"
              />
              <span class="checkmark"></span>
              <label
                class="label_subscribe_newsletter"
                for="subscribe_newsletter"
                >{{ strings.subscribe_newsletter }}</label
              >
            </div>

            <!-- t&c -->
            <div class="gdpr_wrapper gdpr_wrapper--black">
              <input
                type="checkbox"
                id="accept_tc_1"
                name="accept_tc_1"
                value="Accept T&C"
                required
              />
              <span class="checkmark"></span>
              <label class="label_accept_tc_1" for="accept_tc_1">{{
                strings.programeaza_intalnire_accept_termeni
              }}</label>
            </div>
            <input
              type="submit"
              :value="strings.programeaza_intalnire_accept_trimite"
            />
          </form>
          <h6>{{ strings.programeaza_intalnire_thanks }}</h6>
        </div>
      </div>
    </div>

    <!-- formular brosura -->
    <div class="download-form">
      <div class="download-form-shape mask-left">
        <div class="download-form-col">
          <a href="#" @click.prevent="DownloadForm(false)">
            <svg
              width="47"
              height="44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke="#000"
                stroke-width="2"
                d="M2.6976 1.2835l43.0645 41.9334M44.3669 1.2835L1.3024 43.217"
              />
            </svg>
          </a>
        </div>
        <div class="download-form-col">
          <h5>
            {{ strings.brosura_headline }}
          </h5>
          <form
            class="form-styles form-styles--dark form-styles--w70"
            @submit="submitForm"
            action="#"
            method="post"
          >
            <input
              type="hidden"
              id="form_type"
              name="form_type"
              value="brochure"
            />
            <input
              type="text"
              name="user_name"
              id="user_name"
              v-model="user_name"
              value=""
              :placeholder="strings.programeaza_intalnire_nume"
              required
            />
            <input
              type="email"
              name="user_email"
              id="user_email"
              v-model="user_email"
              value=""
              :placeholder="strings.programeaza_intalnire_email"
              required
            />
            <input
              type="tel"
              name="user_phone"
              pattern="[0-9]{4}[0-9]{3}[0-9]{3}"
              id="user_phone"
              v-model="user_phone"
              value=""
              :placeholder="strings.programeaza_intalnire_tel"
              required
            />

            <div class="gdpr_wrapper gdpr_wrapper--black">
              <input
                type="checkbox"
                id="label_accept_tc_3"
                name="label_accept_tc_3"
                value="Accept T&C"
                required
              />
              <span class="checkmark"></span>
              <label class="label_accept_tc_1" for="label_accept_tc_3">{{
                strings.programeaza_intalnire_accept_termeni
              }}</label>
            </div>
            <input type="submit" :value="strings.descarca" />
          </form>
        </div>
      </div>
    </div>

    <!-- step-in 3d -->
    <div class="step-in-view">
      <div class="step-in-view-shape mask-left">
        <div class="viewer3d">
          <model-fbx :src="content.apartments.data[0].mediaFiles.level_6"
              :backgroundAlpha="0"
              :cameraPosition="{ x: 0, y: 900, z: 2000 }"
              :width="viewportW"
              :height="viewportH"
              :glOptions="{ antialias: true, alpha: true }"
              :controlsOptions="{
                enablePan,
                enableZoom,
                enableRotate,
                maxPolarAngle: Math.PI/2,
                minDistance: 1000,
                maxDistance: 2200
              }"
              @on-load="onModelLoad()"
          >
        </model-fbx>
        </div>
        <a href="#" @click.prevent="StepIn(false)">
          <svg
            width="47"
            height="44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke="#f9df41"
              stroke-width="2"
              d="M2.6976 1.2835l43.0645 41.9334M44.3669 1.2835L1.3024 43.217"
            />
          </svg>
        </a>
      </div>
    </div>

    <!-- Hero module -->
    <div
      id="hero"
      class="project-hero mask-right"
      :style="{
        backgroundImage: 'url(' + content.mediaFiles.image_top_mobile + ')'
      }"
    >
      <div class="home-hero-content">
        <!-- mobile: play video -->
        <div class="mobile-video" v-if="isMobile">
          <video class="fullscreen-video">
            <source :src="content.mediaFiles.top_cover" type="video/mp4" />
          </video>
        </div>

        <!-- desktop video -->
        <video autoplay muted loop v-if="!isMobile">
          <source :src="content.mediaFiles.top_cover" type="video/mp4" />
        </video>
        <!-- -->
        <div class="video-controls" data-playing="false" v-if="isMobile">
          <!-- pause -->
          <a href="#" class="pause" @click.prevent="toggleVideo(false)">
            <svg
              width="31"
              height="31"
              fill="#fff"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="15.5"
                cy="15.5"
                r="15.155"
                stroke="#fff"
                stroke-width=".69"
              />
              <path
                stroke="#000"
                stroke-width=".69"
                d="M12.345 11v10M19.345 11v10"
              />
            </svg>
          </a>

          <!-- play btn -->
          <a href="#" class="play" @click.prevent="toggleVideo(true)">
            <svg
              width="31"
              height="31"
              fill="#fff"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="15.5"
                cy="15.5"
                r="15.155"
                stroke="#fff"
                stroke-width=".69"
              />
              <path
                d="M21 15.7273L12 10v10.6364l9-4.9091z"
                stroke="#000"
                stroke-width=".5871"
              />
            </svg>
          </a>
        </div>
        <div class="home-hero-content-wrapper content"></div>
      </div>
    </div>

    <!-- Section: details -->
    <div class="section-wrapper section-wrapper--projectdetails">
      <div class="project-details-shadow our-projects-shadow mask-left active">
        <h2>{{ content.name }}</h2>
      </div>

      <!-- Project details -->
      <div
        class="project-details our-projects project-details-mask mask-right active"
      >
        <!-- list -->
        <div class="project-details-wrapper our-projects-wrapper">
          <!-- project block -->
          <div class="project-details-block our-projects-block">
            <!-- title -->
            <div class="project-details-block-title">
              <h5>{{ content.year }}</h5>
              <span class="v-spacer"></span>
              <h5>{{ content.address }}</h5>
              <span class="v-spacer"></span>
              <h5>{{ content.status }}</h5>
              <router-link
                v-if="
                  this.$route.params.slug === 'precupetii-vechi' ||
                    this.$route.params.slug === 'fainari'
                "
                v-bind:to="
                  '/etapele-lucrarii?project=' + this.$route.params.slug
                "
                class="button btn-evolutie-lucrari"
                ><svg
                  width="42"
                  height="43"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <ellipse
                    cx="21"
                    cy="21.3682"
                    rx="21"
                    ry="21.3684"
                    fill="#fff"
                  />
                  <path
                    d="M8.4334 34.4732h20.8c.2394 0 .4334-.1974.4334-.4408v-3.9685H32.7c.2394 0 .4334-.1974.4334-.4408v-4.4095c0-.2434-.194-.4408-.4334-.4408h-3.0332v-3.9685c0-.2436-.194-.441-.4334-.441h-.7953a1.0336 1.0336 0 00-.1771-.8256l-1.9581-2.6559.9042-.6901c.4017-.306.626-.7965.5976-1.3063l-.0434-.7941a.649.649 0 01.2525-.5518l.904-.6899.3804.5159a.4323.4323 0 00.2853.172.4163.4163 0 00.0613.0042.4265.4265 0 00.26-.0882l3.5754-2.7291c.574-.4383.6905-1.2672.2598-1.8516l-.2408-.327c-.4312-.5835-1.2455-.7016-1.82-.264l-3.5749 2.729c-.1914.1461-.2303.4226-.0867.6174l.3803.5159-.904.6901c-.4017.306-.6262.7963-.5977 1.3062l.0433.794a.6481.6481 0 01-.2523.5519l-.904.6901-1.9582-2.6559c-.205-.2824-.5378-.438-.882-.4124-.3283.0243-.6217.218-.7774.5133l-3.5606 6.7419H8.4334c-.2394 0-.4334.1974-.4334.441v4.4093c0 .2436.194.441.4334.441h3.0332v3.5275H8.4334c-.2394 0-.4334.1974-.4334.441v4.4093c0 .2434.194.4408.4334.4408zM32.1993 8.9871a.4284.4284 0 01.6066.088l.2408.327c.1435.1947.1046.4709-.0866.617l-3.2288 2.4647-.7608-1.0322 3.2288-2.4645zM15.8001 30.0639h6.0666v3.5275h-6.0666v-3.5275zm3.4666-4.4093h6.0666v3.5275h-6.0666v-3.5275zm9.5334 7.9368h-6.0667v-3.5275h6.0667v3.5275zm3.4667-4.4093H26.2v-3.5275h6.0668v3.5275zm-3.4667-4.4093h-6.0667v-2.5677l4.4354-.96h1.6313v3.5277zm-5.8708-10.7335a.0905.0905 0 01.079-.0517l.0085-.0004a.1422.1422 0 01.1149.0623l1.9578 2.6559-1.7876 1.3647c-.1915.1461-.2303.4225-.0867.6174a.4287.4287 0 00.6068.0882l1.7876-1.3646 1.9581 2.6558a.1446.1446 0 01.0238.1381.0915.0915 0 01-.0708.0628l-8.5969 1.8602a.1397.1397 0 01-.1377-.06.1424.1424 0 01-.0179-.1509l4.1611-7.8778zm-4.8363 8.558c.2309.3231.6272.4771 1.0111.3932l2.7626-.5979v2.3802h-6.0666v-3.5277h2.3389l-.1343.2543a1.0286 1.0286 0 00.0883 1.0979zm-9.2263.4117v-.2071c.2394 0 0 .039 0-.2046 0-.2434.2394-.2047 0-.2047v-1.1475h6.0667v3.5277H8.8667V23.009zm3.4666 2.6456h6.0668v3.5275h-6.0668v-3.5275zm-3.4666 4.4093h6.0667v3.5275H8.8667v-3.5275z"
                    fill="#000"
                  />
                </svg>
                {{ strings.vezi_evolutia }}</router-link
              >
            </div>
          </div>

          <!-- project block -->
          <div
            class="project-details-block project-details-block--row our-projects-block"
          >
            <!-- item -->
            <div class="project-details-block-item">
              <svg
                width="133"
                height="106"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="125.765"
                  height="45.1551"
                  rx="22.4908"
                  transform="matrix(.99289 .11906 -.16479 .98633 7.9133 32.2227)"
                  fill="#F9DF41"
                />
                <path
                  d="M8.19 53.8818L68.3657 2l59.8232 51.8818"
                  stroke="#000"
                  stroke-width="2.2052"
                  stroke-linecap="round"
                />
                <path
                  d="M26.5428 35.8833V14.707h11.294v12.7058M23.1899 104V52.2949L68.013 14.707l44.823 37.5879V104H78.7776V75.9417H57.9543V104H23.1899z"
                  stroke="#000"
                  stroke-width="2.2052"
                  stroke-linecap="round"
                />
              </svg>
              <h6>
                <number
                  :class="{ scaleBig: scaleClass }"
                  ref="number1"
                  :from="0"
                  animationPaused
                  :to="content.amenities.apartments"
                  :duration="duration"
                  easing="Power1.easeOut"
                  v-observe-visibility="{
                    callback: (isVisible, entry) =>
                      visibilityChanged(isVisible, entry, 'numbers'),
                    intersection: {
                      threshold: 0.3
                    }
                  }"
                />
                <span>{{ strings.apartamente }}</span>
              </h6>
            </div>
            <!-- item -->
            <div class="project-details-block-item">
              <svg
                width="133"
                height="84"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="114.062"
                  height="40.9534"
                  rx="20.3981"
                  transform="matrix(.99289 .11906 -.16479 .98633 12.6133 17)"
                  fill="#F9DF41"
                />
                <path
                  d="M21.2121 20.4155l.0499.9988.4082-.0205.2771-.3005-.7352-.6778zM6.9538 45.8983l-.9999.0164.0067.4046.2861.2862.7071-.7072zm7.8876 7.8876l-.7072.7071.2929.2929h.4143v-1zm3.337 0l.9252-.3796-.2546-.6204h-.6706v1zm30.6401 0v-1h-.6476l-.2649.5909.9125.4091zm37.0108 0l.8854-.4648-.281-.5352h-.6044v1zm29.9527.6451l.862.508-.862-.508zm.384-.6451v-1h-.563l-.292.481.855.519zm3.944 0v1h.313l.258-.1791-.571-.8209zm6.977-4.8539l.571.8209.429-.2984v-.5225h-1zm0-18.202h1v-.6789l-.631-.2505-.369.9294zm-20.629-8.1909l-.619.7851.115.0904.135.0539.369-.9294zM79.1552 1l.6194-.7851L79.5022 0h-.347v1zM39.1107 1V0h-.4382l-.297.3222.7352.6778zm3.4645 6.6744v-1h-.4491l-.2983.3356.7474.6644zm9.4044 0h1v-1h-1v1zM30.4405 21.3259l-.7474-.6644-.2526.2842v.3802h1zm0 2.4269h-1v1h1v-1zm21.5391 0v1h1v-1h-1zm9.7081-16.0784v-1h-1v1h1zm16.0785 0l.6616-.7499-.2835-.2501h-.3781v1zM61.6877 23.7528h-1v1h1v-1zm31.5502 0v1h1v-1h-1zm0-2.4269h1v-.4513l-.3384-.2986-.6616.7499zm-85.313 5.3959c-.0406.1646-.1166.2242-.0604.1613.0378-.0423.1136-.1149.2428-.2173.2566-.2033.6404-.4589 1.1393-.753.9922-.5848 2.3495-1.2691 3.8368-1.9287 1.4855-.6587 3.0799-1.2834 4.5426-1.7539 1.4818-.4767 2.759-.7721 3.636-.8159l-.0999-1.9976c-1.1454.0573-2.6244.4192-4.1486.9095-1.5432.4965-3.2046 1.1484-4.7408 1.8296-1.5342.6803-2.9644 1.3991-4.0417 2.0341-.5357.3157-1.0071.6242-1.3657.9084-.1784.1413-.3502.2933-.4924.4525-.1238.1386-.3123.3768-.3901.6931l1.942.4779zm-.9711 19.1765l.9999-.0165v-.0007-.0024l-.0002-.0098a1174.2544 1174.2544 0 01-.1117-9.2312c-.0187-2.3496-.028-4.7325-.014-6.6018.007-.9355.0197-1.7361.0397-2.3372.01-.3012.0216-.5448.0346-.7269.0148-.2086.0274-.2689.0227-.25l-1.942-.4779c-.042.1705-.062.3946-.0757.586-.0155.2179-.028.4897-.0385.8024-.0208.6266-.0337 1.4471-.0408 2.3887-.014 1.8849-.0046 4.28.014 6.6326a1175.29 1175.29 0 00.0701 6.3952 1273.594 1273.594 0 00.0412 2.8134l.0006.0392.0002.01v.0031c0 .0002 0 .0002.9999-.0162zm8.5947 7.1805l-7.8876-7.8876-1.4142 1.4143 7.8875 7.8875 1.4143-1.4142zm2.6299-.2929h-3.337v2h3.337v-2zm15.7751 10.3145c-8.2972 0-13.3357-6.003-14.8499-9.6941l-1.8504.7592c1.7217 4.1965 7.3558 10.9349 16.7003 10.9349v-2zm13.9525-9.7236c-.6058 1.3513-2.1184 3.8101-4.4918 5.9184-2.3623 2.0986-5.5234 3.8052-9.4607 3.8052v2c4.5569 0 8.1711-1.9844 10.789-4.3099 2.607-2.3159 4.2796-5.0142 4.9885-6.5955l-1.825-.8182zm37.9233-.5909H48.8185v2h37.0108v-2zm15.7747 10.3145c-3.5523 0-6.7576-1.454-9.3584-3.4358-2.6057-1.9856-4.5378-4.4519-5.5309-6.3435l-1.7708.9296c1.1304 2.1533 3.2543 4.8442 6.0895 7.0047 2.8401 2.1641 6.4605 3.845 10.5706 3.845v-2zm13.317-9.1773c-1.89 3.2047-5.458 9.1773-13.317 9.1773v2c9.094 0 13.181-7.0088 15.04-10.1614l-1.723-1.0159zm.39-.6562c-.122.201-.253.4233-.39.6562l1.723 1.0159c.139-.2358.263-.4463.377-.6341l-1.71-1.038zm4.799-.481h-3.944v2h3.944v-2zm6.406-4.6748l-6.977 4.8539 1.142 1.6418 6.977-4.8539-1.142-1.6418zm-.429-17.3811v18.202h2V30.73h-2zm-19.998-7.2615l20.629 8.1909.738-1.8588-20.629-8.1909-.738 1.8588zM78.5358 1.7851l27.3032 21.5391 1.239-1.5702L79.7746.2149 78.5358 1.785zM39.1107 2h40.0445V0H39.1107v2zM21.9473 21.0933L39.846 1.6778 38.3755.3222 20.4768 19.7377l1.4705 1.3556zm11.8305 37.0294c5.2436 0 9.4943-4.2507 9.4943-9.4943h-2c0 4.139-3.3553 7.4943-7.4943 7.4943v2zm-9.4943-9.4943c0 5.2436 4.2508 9.4943 9.4943 9.4943v-2c-4.139 0-7.4943-3.3553-7.4943-7.4943h-2zm9.4943-9.4942c-5.2435 0-9.4943 4.2507-9.4943 9.4942h2c0-4.1389 3.3553-7.4942 7.4943-7.4942v-2zm9.4943 9.4942c0-5.2435-4.2507-9.4942-9.4943-9.4942v2c4.139 0 7.4943 3.3553 7.4943 7.4942h2zm65.9539 0c0 4.139-3.355 7.4943-7.494 7.4943v2c5.244 0 9.494-4.2507 9.494-9.4943h-2zm-7.494-7.4942c4.139 0 7.494 3.3553 7.494 7.4942h2c0-5.2435-4.25-9.4942-9.494-9.4942v2zm-7.4941 7.4942c0-4.1389 3.3553-7.4942 7.4941-7.4942v-2c-5.2434 0-9.4941 4.2507-9.4941 9.4942h2zm7.4941 7.4943c-4.1388 0-7.4941-3.3553-7.4941-7.4943h-2c0 5.2436 4.2507 9.4943 9.4941 9.4943v-2zM42.5752 8.6744h9.4044v-2h-9.4044v2zM31.1879 21.9902L43.3226 8.3387 41.8278 7.01 29.6931 20.6615l1.4948 1.3287zm.2526 1.7626v-2.4269h-2v2.4269h2zm20.5391-1H30.4405v2h21.5391v-2zm-1-15.0784v16.0784h2V7.6744h-2zm10.7081 1h16.0785v-2H61.6877v2zm1 15.0784V7.6744h-2v16.0784h2zm30.5502-1H61.6877v2h31.5502v-2zm-1-1.4269v2.4269h2v-2.4269h-2zM77.1046 8.4242l15.4717 13.6515 1.3232-1.4997L78.4278 6.9245l-1.3232 1.4997z"
                  fill="#000"
                />
                <path
                  d="M1.728 82.0987v-18.022h10.9436v10.4337h60.9711l-4.69-10.4337h6.8788l6.5661 10.4337H131.8v7.5883H1.728z"
                  stroke="#000"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
              <h6>
                <number
                  :class="{ scaleBig: scaleClass }"
                  ref="number2"
                  :from="0"
                  animationPaused
                  :to="content.amenities.parking_spots"
                  :duration="duration"
                  easing="Power1.easeOut"
                  v-observe-visibility="{
                    callback: (isVisible, entry) =>
                      visibilityChanged(isVisible, entry, 'numbers'),
                    intersection: {
                      threshold: 0.3
                    }
                  }"
                />
                <span>{{ strings.parcare }}</span>
              </h6>
            </div>
            <!-- item -->
            <div class="project-details-block-item">
              <svg
                width="133"
                height="106"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="125.765"
                  height="45.1552"
                  rx="22.4909"
                  transform="matrix(.99289 .11906 -.16479 .98633 7.9127 32.2227)"
                  fill="#F9DF41"
                />
                <path
                  d="M15.982 29.6296v74.3694h8.5192V39.6453h86.5728v64.3537h6.792V29.6296L67.0967 2 15.982 29.6296z"
                  stroke="#000"
                  stroke-width="2.2052"
                  stroke-linecap="round"
                />
                <path
                  d="M67.2121 81.7812h-6.562V104H82.063V81.7812h-6.6772m-8.1737 0v7.9435h8.1737v-7.9435m-8.1737 0h8.1737M88.7405 81.7812h-6.562V104h21.4125V81.7812h-6.6767m-8.1738 0v7.9435h8.1738v-7.9435m-8.1738 0h8.1738M88.7405 59.4478h-6.562v22.2187h21.4125V59.4478h-6.6767m-8.1738 0v7.9435h8.1738v-7.9435m-8.1738 0h8.1738"
                  stroke="#000"
                  stroke-width="2.2052"
                  stroke-linecap="round"
                />
              </svg>
              <h6>
                <number
                  :class="{ scaleBig: scaleClass }"
                  ref="number3"
                  :from="0"
                  animationPaused
                  :to="content.amenities.basement_box"
                  :duration="duration"
                  easing="Power1.easeOut"
                  v-observe-visibility="{
                    callback: (isVisible, entry) =>
                      visibilityChanged(isVisible, entry, 'numbers'),
                    intersection: {
                      threshold: 0.3
                    }
                  }"
                />
                <span>{{ strings.boxe }}</span>
              </h6>
            </div>
            <!-- item -->
            <div class="project-details-block-item">
              <svg
                width="122"
                height="107"
                viewBox="0 0 122 107"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="114.062"
                  height="40.9534"
                  rx="20.3981"
                  transform="matrix(0.992887 0.119059 -0.164786 0.986329 8.5343 37)"
                  fill="#F9DF41"
                />
                <rect
                  x="15.9487"
                  y="47.9531"
                  width="27.4724"
                  height="53.5667"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <rect
                  x="20.5654"
                  y="54.6367"
                  width="7.47736"
                  height="5.46852"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <rect
                  x="32.1505"
                  y="54.6367"
                  width="7.47736"
                  height="5.46852"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <rect
                  x="20.5654"
                  y="64"
                  width="7.47736"
                  height="5.46852"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <rect
                  x="32.1505"
                  y="64"
                  width="7.47736"
                  height="5.46852"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <rect
                  x="20.5654"
                  y="73"
                  width="7.47736"
                  height="5.46852"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <rect
                  x="32.1505"
                  y="73"
                  width="7.47736"
                  height="5.46852"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <rect
                  x="43.7322"
                  y="1"
                  width="38.8416"
                  height="100.521"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  d="M82.323 2.50074L83.4343 1.52832L102.466 21.0602L102.126 101.41H82.323L82.323 2.50074Z"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <rect
                  x="49.0588"
                  y="7.78906"
                  width="27.5688"
                  height="5.46852"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <rect
                  x="49.0588"
                  y="30"
                  width="27.5688"
                  height="5.46852"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <rect
                  x="49.0588"
                  y="52"
                  width="27.5688"
                  height="5.46852"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <rect
                  x="49.0588"
                  y="19"
                  width="27.5688"
                  height="5.46852"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <rect
                  x="49.0588"
                  y="41.2109"
                  width="27.5688"
                  height="5.46852"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <rect
                  x="49.0588"
                  y="63.2109"
                  width="27.5688"
                  height="5.46852"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <rect
                  x="49.0588"
                  y="73"
                  width="27.5688"
                  height="5.46852"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  d="M1.89062 105.299H110.524"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>

              <h6>
                <number
                  :class="{ scaleBig: scaleClass }"
                  ref="number4"
                  :from="0"
                  animationPaused
                  :to="content.amenities.square_meters"
                  :duration="duration"
                  easing="Power1.easeOut"
                  v-observe-visibility="{
                    callback: (isVisible, entry) =>
                      visibilityChanged(isVisible, entry, 'numbers'),
                    intersection: {
                      threshold: 0.3
                    }
                  }"
                />
                m² <span>{{ strings.construiti }}</span>
              </h6>
            </div>
            <!-- item -->
            <div class="project-details-block-item">
              <svg
                width="133"
                height="98"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="125.765"
                  height="45.1552"
                  rx="22.4909"
                  transform="matrix(.99289 .11906 -.16479 .98633 7.441 25.2227)"
                  fill="#F9DF41"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.1289 58.2845l-.556-.4447-.5611.4381-5.5662 4.3461-.3465.2705v11.4724h1.8017V63.7735l4.6587-3.6374 4.5396 3.6309v10.5999h1.8017V62.901l-.3382-.2705-5.4337-4.346zm5.7719 25.8651h-1.8017v11.9376H8.9008V84.1496H7.099v13.7392h12.8017V84.1496z"
                  fill="#000"
                />
                <path
                  stroke="#000"
                  stroke-width="1.8016"
                  d="M4.9008 75.268h73.1984v7.981H4.9008z"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M28.1289 58.2904l-.556-.4447-.5611.4381-5.5662 4.346-.3465.2705v11.4666h1.8017V63.7794l4.6587-3.6374 4.5396 3.6309v10.594h1.8017V62.9069l-.3382-.2705-5.4337-4.346zm5.7719 25.8592h-1.8017V96.093h-9.1983V84.1496h-1.8017V97.8946h12.8017V84.1496zM42.1289 58.2904l-.556-.4447-.5611.4381-5.5662 4.346-.3465.2705v11.4666h1.8017V63.7794l4.6587-3.6374 4.5396 3.6309v10.594h1.8017V62.9069l-.3382-.2705-5.4337-4.346zm5.7719 25.8592h-1.8017V96.093h-9.1983V84.1496h-1.8017V97.8946h12.8017V84.1496zM56.1289 58.2962l-.556-.4446-.5611.4381-5.5662 4.346-.3465.2705V74.3669h1.8017V63.7853l4.6587-3.6375 4.5396 3.6309v10.5882h1.8017V62.9127l-.3382-.2704-5.4337-4.3461zm5.7719 25.8534h-1.8017v11.9493h-9.1983V84.1496h-1.8017v13.7509h12.8017V84.1496zM70.1289 58.2962l-.556-.4446-.5611.4381-5.5662 4.346-.3465.2705V74.3669h1.8017V63.7853l4.6587-3.6375 4.5396 3.6309v10.5882h1.8017V62.9127l-.3382-.2704-5.4337-4.3461zm5.7719 25.8534h-1.8017v11.9493h-9.1983V84.1496h-1.8017v13.7509h12.8017V84.1496zM108.129 58.2845l-.556-.4447-.561.4381-5.566 4.3461-.347.2705v11.4724h1.802V63.7735l4.658-3.6374 4.54 3.6309v10.5999h1.802V62.901l-.338-.2705-5.434-4.346zm5.772 25.8651h-1.802v11.9376h-9.198V84.1496h-1.802v13.7392h12.802V84.1496z"
                  fill="#000"
                />
                <path
                  stroke="#000"
                  stroke-width="1.8016"
                  d="M98.9008 75.268h31.1984v7.981H98.9008z"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M122.129 58.2904l-.556-.4447-.561.4381-5.566 4.346-.347.2705v11.4666h1.802V63.7794l4.658-3.6374 4.54 3.6309v10.594h1.802V62.9069l-.338-.2705-5.434-4.346zm5.772 25.8592h-1.802V96.093h-9.198V84.1496h-1.802V97.8946h12.802V84.1496z"
                  fill="#000"
                />
                <circle
                  cx="63.5"
                  cy="32.5"
                  r="11.395"
                  stroke="#000"
                  stroke-width="2.21"
                />
                <circle
                  cx="107.5"
                  cy="35.5"
                  r="8.395"
                  stroke="#000"
                  stroke-width="2.21"
                />
                <circle
                  cx="87.5"
                  cy="15.5"
                  r="14.395"
                  stroke="#000"
                  stroke-width="2.21"
                />
                <path fill="#000" d="M87 29h2v68h-2z" />
                <path
                  fill="#000"
                  d="M101.676 41.9004l1.6857 1.0764-14.667 22.9694-1.6857-1.0764z"
                />
                <path
                  fill="#000"
                  d="M71.5713 40.5195l-1.6857 1.0764 17.4252 27.2887 1.6856-1.0764z"
                />
                <path stroke="#000" stroke-width="2" d="M2 97h131" />
              </svg>

              <h6>
                <number
                  :class="{ scaleBig: scaleClass }"
                  ref="number5"
                  :from="0"
                  animationPaused
                  :to="content.amenities.garden"
                  :duration="duration"
                  easing="Power1.easeOut"
                  v-observe-visibility="{
                    callback: (isVisible, entry) =>
                      visibilityChanged(isVisible, entry, 'numbers'),
                    intersection: {
                      threshold: 0.3
                    }
                  }"
                />
                m² <span>{{ strings.gradina }}</span>
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section: single img right -->
    <div class="section-wrapper section-wrapper--m0">
      <div
        class="single-img mask-right single-img--four"
        :style="{
          backgroundImage: 'url(' + content.mediaFiles.image_2 + ')'
        }"
        :class="{ active: maskR1 }"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'maskR1'),
          intersection: {
            threshold: 0.3
          }
        }"
      ></div>
    </div>
    <!--  content -->
    <div class="subsection-wrapper margintop" v-if="content.title">
      <div class="shape shape--notitle"></div>
      <div class="about-us-content content active">
        <h3>
          {{ content.title }}
        </h3>
        <p>
          {{ content.subtitle }}
        </p>
        <p>
          {{ content.shortDescription }}
        </p>
      </div>
    </div>

    <!--  Section: aproape de tot -->
    <div
      class="subsection-wrapper nearbydetails"
      v-if="this.content.nearBy[0].distance"
    >
      <div class="content active">
        <h3>
          {{ strings.aproape_de_tot }}
        </h3>
        <ul class="nearbydetails-list">
          <!-- items -->
          <li
            v-for="(item, index) in content.nearBy"
            :key="index"
            class="nearbydetails-item "
            :class="'nearbydetails-item--' + item.by"
          >
            <span class="text">
              <span>{{ item.distance }}</span>
              <span>{{ item.destination }}</span>
            </span>
          </li>
          <!-- last item -->
          <li class="nearbydetails-item nearbydetails-item--final">
            <span class="text">
              <span>{{ zona_impanzita[0] }}</span>
              <span>{{ zona_impanzita[1] }}</span>
            </span>
          </li>
        </ul>
      </div>
    </div>

    <!-- Section: single img right -->
    <div class="section-wrapper" v-if="content.mediaFiles.image_3">
      <div
        class="single-img mask-right single-img--four"
        :style="{
          backgroundImage: 'url(' + content.mediaFiles.image_3 + ')'
        }"
        :class="{ active: maskR2 }"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'maskR2'),
          intersection: {
            threshold: 0.3
          }
        }"
      ></div>
    </div>
    <!--  content -->
    <div
      class="subsection-wrapper margintop"
      v-if="this.content.secondSubtitle.length > 5"
    >
      <div class="shape shape--notitle"></div>
      <div class="about-us-content content active">
        <h3>
          {{ content.secondSubtitle }}
        </h3>
        <p>
          {{ content.description }}
        </p>
      </div>
    </div>

    <!-- Section: Int/Ext structure -->
    <div
      class="section-wrapper section-wrapper--int-ext"
      v-if="content.mediaFiles.interior"
    >
      <div
        class="int-ext-shadow mask-left"
        :class="{ active: maskR3 }"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'maskR3'),
          intersection: {
            threshold: 0.3
          }
        }"
      >
        <h2>
          {{ sliderText1.active }} <span>{{ sliderText.active }}</span>
        </h2>
      </div>
      <div
        class="int-ext mask-right"
        :class="{ active: maskR3 }"
        v-if="content.mediaFiles.interior"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'maskR3'),
          intersection: {
            threshold: 0.3
          }
        }"
      >
        <VueSlickCarousel v-bind="settings" @afterChange="swipeIntExt">
          <div><img :src="content.mediaFiles.interior" alt="" /></div>
          <div><img :src="content.mediaFiles.exterior" alt="" /></div>
        </VueSlickCarousel>
      </div>
    </div>

    <!-- Section: materials -->
    <div
      class="section-wrapper section-wrapper--materials"
      v-if="content.mediaFiles.interior"
    >
      <v-collapse-wrapper>
        <span
          class="button"
          v-collapse-toggle
          :class="{ 'button--collapse': isMaterialeVisible }"
          @click="toggleMaterialeList"
        >
          {{ strings.vezi_materiale }} <span>{{ sliderText.active }} </span>
          <svg
            width="28"
            height="9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1.1821.629l12.8604 7.7857L26.9028.6289" stroke="#000" />
          </svg>
        </span>

        <div class="materials" v-collapse-content>
          <ul
            class="materials-list"
            v-if="sliderText.active === strings.exterioare"
          >
            <li
              class="materials-item"
              v-for="(material, index) in content.materials.exterior"
              :key="`materialExt-${index}`"
            >
              {{ material }}
            </li>
          </ul>
          <ul
            class="materials-list"
            v-if="sliderText.active === strings.interioare"
          >
            <li
              class="materials-item"
              v-for="(material, index) in content.materials.interior"
              :key="`materialInt-${index}`"
            >
              {{ material }}
            </li>
          </ul>
          <span class="materials-text">{{ strings.lista_completa }}</span>
          <a
            href="#"
            class="button button--download"
            @click.prevent="DownloadForm(true)"
            @keydown.esc="DownloadForm(false)"
            title="Download brochure"
            ><svg
              width="23"
              height="26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.6464 19.3536a.5002.5002 0 00.7072 0l3.1819-3.182a.5.5 0 000-.7071.5.5 0 00-.7071 0L12 18.2929l-2.8284-2.8284a.5.5 0 10-.7071.7071l3.1819 3.182zM11.5 0v19h1V0h-1z"
                fill="#000"
              />
              <path stroke="#000" d="M0 25.5h23" /></svg
          ></a>
        </div>
      </v-collapse-wrapper>
    </div>

    <!-- Section: Apart. types -->
    <div
      class="section-wrapper section-wrapper--apartments"
      ref="apartSlideWrapper"
      v-if="content.apartments.data.length > 0"
    >
      <div class="project-details-shadow our-projects-shadow mask-left active">
        <h2>{{ strings.tipuri_apartamente }}</h2>
      </div>

      <!-- Apart details -->
      <div class="project-details our-projects mask-right active"></div>
      <div class="apart-details">
        <VueSlickCarousel v-bind="settings3" @beforeChange="beforeApartSlide">
          <div
            class="apart-item"
            v-for="apartament in apartamente"
            :data-id="[apartament.id]"
            :key="apartament.id"
          >
            <div class="apart-item-headline">
              <h4>
                {{ apartament.nume }} <br />
                {{ apartament.etaj }}
              </h4>
              <!-- <h4>{{ apartament.etaj }}</h4> -->
            </div>
            <div class="apart-item-subheadline">
              <h5>
                {{ strings.tip_apartament }}
                <span>{{ apartament.type }}</span>
              </h5>
              <h5>
                {{ strings.orientare }}
                <span
                  ><svg
                    width="59"
                    height="54"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      r="15.4707"
                      transform="rotate(-36.0324 60.4394 -19.5176) skewX(-.0008)"
                      stroke="#000"
                      stroke-width=".8"
                    />
                    <path
                      d="M10.2097 41.1547l22.1681-21.4092-13.8876 27.0857"
                      stroke="#000"
                      stroke-width=".8"
                    />
                    <path
                      d="M36.7955 20.3711l-.9228-.7402.8192-8.6257-4.5306 5.6485-.9228-.7402 5.7344-7.1494.9228.7402-.8273 8.6359 4.5387-5.6587.9228.7402-5.7344 7.1494z"
                      fill="#000"
                    /></svg
                ></span>
              </h5>
              <h5>
                {{ strings.suprafata_utila }}
                <span>{{ apartament.surface }}</span>
              </h5>
            </div>

            <!-- cta 3d view -->
            <a
              id="stepin-3d-btn"
              target="_blank"
              v-if="apartament.mediaFiles.level_6"
              @click.prevent="StepIn(true)"
              class="button btn-step-in"
              ><svg width="42" height="43" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="21" cy="21.368" rx="21" ry="21.368" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15 20.386c-1.442.135-2.756.31-3.898.516-1.419.257-2.589.566-3.413.92-.41.175-.756.37-1.004.59-.247.218-.438.499-.438.838 0 .34.191.62.438.84.248.219.593.414 1.004.59.824.352 1.994.662 3.413.919 1.424.258 3.117.466 4.993.61l-.138-.736c-1.777-.141-3.378-.341-4.726-.585-1.398-.253-2.507-.551-3.258-.873-.377-.161-.643-.32-.81-.467-.167-.149-.194-.248-.194-.297 0-.05.027-.15.195-.298.166-.147.432-.306.81-.467.75-.322 1.86-.62 3.257-.873a46.04 46.04 0 0 1 3.904-.514L15 20.386Zm17.899 4.54c1.137-.198 2.099-.426 2.846-.675.584-.195 1.016-.396 1.293-.592.29-.204.337-.346.337-.409 0-.049-.027-.148-.195-.297-.166-.147-.432-.306-.81-.467-.75-.322-1.86-.62-3.257-.873l-.214-.038v-.733l.343.06c1.419.257 2.589.566 3.413.92.41.175.756.37 1.004.59.247.218.438.499.438.838 0 .424-.293.754-.643 1-.36.254-.868.482-1.48.686-.817.272-1.859.516-3.075.723v-.733Z" fill="#000"/><path d="m22.256 21.021-5.384-8.034-6.142 5.763h1.052v8.413L22.256 32V21.02ZM24.15 22.283l-6.479-9.675L27.01 10l6.94 8.75-9.8 3.533ZM23.266 32v-9.338l.547.757.84-.295 8.245-3.07v7.109L23.267 32Z" fill="#F9DF41"/><path d="m29.786 25.817-3.704-1.92.189 4.167 3.515-2.247Zm-7.614-.11c-4.283 0-8.152-.314-10.941-.82-1.398-.252-2.507-.55-3.258-.872-.377-.161-.643-.32-.81-.467-.167-.149-.194-.248-.194-.297h-.722c0 .34.191.62.438.838.248.22.593.415 1.004.59.824.354 1.994.663 3.413.92 2.844.515 6.757.831 11.07.831v-.723Zm4.353-.104c-1.626.058-3.362.104-4.353.104v.723c1.005 0 2.752-.047 4.379-.105l-.026-.722Zm10.85-2.353c0 .063-.047.205-.337.41-.277.195-.709.396-1.293.59-1.164.389-2.851.726-4.91.978l.088.717c2.08-.254 3.82-.599 5.05-1.009.613-.204 1.12-.432 1.481-.686.35-.246.643-.576.643-1h-.722Z" fill="#000"/><path d="M4 12.692h11.904l-6.231 5.89H4v-5.89Z" fill="#F9DF41"/><path d="M6.402 17.012c-.28 0-.519-.058-.717-.174a.915.915 0 0 1-.403-.51l.551-.241c.02.102.053.187.098.255a.43.43 0 0 0 .183.148c.079.034.172.05.28.05a.52.52 0 0 0 .241-.05.37.37 0 0 0 .157-.144.409.409 0 0 0 .055-.212.383.383 0 0 0-.05-.208.257.257 0 0 0-.145-.115.68.68 0 0 0-.246-.038 1.29 1.29 0 0 0-.106.004.752.752 0 0 0-.106.009v-.429l.068.009h.076c.159 0 .272-.031.34-.094.07-.065.106-.168.106-.31 0-.115-.036-.204-.106-.267-.068-.065-.166-.097-.293-.097a.479.479 0 0 0-.322.102.528.528 0 0 0-.166.3l-.522-.194a.79.79 0 0 1 .195-.365.975.975 0 0 1 .365-.234c.145-.056.304-.084.48-.084.209 0 .383.032.522.097a.7.7 0 0 1 .428.658.723.723 0 0 1-.055.297.64.64 0 0 1-.306.326.527.527 0 0 1-.165.051v.013a.647.647 0 0 1 .2.043.559.559 0 0 1 .33.292.582.582 0 0 1 .055.263c0 .17-.045.32-.135.45a.87.87 0 0 1-.36.297 1.285 1.285 0 0 1-.527.102Zm2.43-2.843c.439 0 .778.122 1.019.365.24.24.36.586.36 1.035 0 .447-.12.792-.36 1.036-.24.243-.58.364-1.019.364H7.751v-2.8h1.081Zm-.03 2.334c.267 0 .466-.08.599-.238.136-.161.204-.393.204-.696 0-.302-.068-.533-.204-.691-.133-.161-.332-.242-.598-.242h-.467v1.867h.467Z" fill="#000"/></svg>step in.3D</a
            >
            <div
              class="apart-item-floors"
              v-if="apartament.mediaFiles.level_3"
              :data-slide="1"
            >
              <button
                class="button button--white"
                type="button"
                name="button"
                @click="changeFloorPlan($event, 1, apartament.id)"
              >
                {{ strings.nivel }} 1
              </button>
              <button
                class="button button--white"
                type="button"
                name="button"
                @click="changeFloorPlan($event, 2, apartament.id)"
              >
                {{ strings.nivel }} 2
              </button>
              <button
                class="button button--white"
                type="button"
                name="button"
                @click="changeFloorPlan($event, 3, apartament.id)"
              >
                {{ strings.nivel }} 3
              </button>
            </div>
            <!-- floor plan -->
            <div class="apart-item-floorplan">
              <div class="apart-item-floorplan-left">
                <ul class="rooms-list">
                  <li
                    class="rooms-list-item"
                    v-for="camera in apartament.roomsDetails"
                    :key="camera.id"
                  >
                    <span class="room-ico">{{ camera.icon }}</span>
                    <span class="room-title">{{ camera.name }}</span>
                    <span class="room-sqm">{{ camera.surface }}</span>
                  </li>
                </ul>
              </div>
              <div class="apart-item-floorplan-right">
                <div class="apart-item-floorplan-wrapper">
                  <img :src="apartament.mediaFiles.level_1" alt="" />
                  <img
                    v-if="apartament.mediaFiles.level_2"
                    :src="apartament.mediaFiles.level_2"
                    alt=""
                  />
                  <img
                    v-if="apartament.mediaFiles.level_3"
                    :src="apartament.mediaFiles.level_3"
                    alt=""
                  />
                  <!-- <img
                    v-for="schita in apartament.mediaFiles"
                    :key="schita.id"
                    :src=""
                    alt=""
                  /> -->
                </div>
              </div>
            </div>
            <!-- position -->
            <div class="apart-item-pos" :class="{ visible: isApartPosActive }">
              <button
                class="button button--white"
                :class="{ 'button--collapse': isApartPosActive }"
                type="button"
                name="button"
                @click="toggleApartPos"
              >
                {{ strings.pozitionare_apartament }}
                <svg
                  width="28"
                  height="9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.1821.629l12.8604 7.7857L26.9028.6289"
                    stroke="#000"
                  />
                </svg>
              </button>
              <img :src="apartament.mediaFiles.level_4" alt="" />
            </div>
          </div>
        </VueSlickCarousel>
      </div>
    </div>

    <!-- tabel -->
    <div
      class="subsection-wrapper subsection-wrapper--table"
      v-if="this.$route.params.slug === 'precupetii-vechi'"
    >
      <div class="table-scroll">
        <ol>
          <li class="header">
            <span>{{ strings.tabel_apt }}</span>
            <span>{{ strings.tabel_nivel }}</span>
            <span>{{ strings.tabel_curte }}</span>
            <span>{{ strings.tabel_terasa }}</span>
            <span>{{ strings.tabel_utili }}</span>
            <span>{{ strings.tabel_camere }}</span>
            <span>{{ strings.tabel_dormitoare }}</span>
            <span>{{ strings.tabel_bai }}</span>
            <span>{{ strings.tabel_disponibilitate }}</span>
          </li>
          <li
            class="item"
            v-for="(item, index) in content.apartmentsSummary"
            :key="index"
          >
            <span>A{{ index + 1 }}</span>
            <span>{{ item.level }}</span>
            <span>{{ item.yard }}</span>
            <span>{{ item.terrace }}</span>
            <span>{{ item.surface }}</span>
            <span>{{ item.rooms }}</span>
            <span>{{ item.bedrooms }}</span>
            <span>{{ item.bathrooms }}</span>
            <span>{{ item.availability }}</span>
          </li>
        </ol>
      </div>
      <span class="download-text">{{ strings.vezi_toate_planurile }}</span>
      <a
        href="#"
        @click.prevent="DownloadForm(true)"
        @keydown.esc="DownloadForm(false)"
        class="button button--download"
        title="Download brochure"
        ><svg>
          <path
            d="M11.6464 19.3536a.5002.5002 0 00.7072 0l3.1819-3.182a.5.5 0 000-.7071.5.5 0 00-.7071 0L12 18.2929l-2.8284-2.8284a.5.5 0 10-.7071.7071l3.1819 3.182zM11.5 0v19h1V0h-1z"
            fill="#000"
          />
          <path stroke="#000" d="M0 25.5h23" /></svg
      ></a>
    </div>

    <!-- Proiectul in imagini -->
    <div class="section-wrapper" v-if="this.content.mediaFiles.image_4">
      <div
        class="project-start-img-shadow mask-left"
        :class="{ active: maskR4 }"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'maskR4'),
          intersection: {
            threshold: 0.3
          }
        }"
      >
        <h2>{{ strings.proiectul_in_imagini }}</h2>
      </div>

      <div
        class="project-start-img mask-right"
        :style="{
          backgroundImage: 'url(' + this.content.mediaFiles.image_4 + ')'
        }"
        :class="{ active: maskR4 }"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'maskR4'),
          intersection: {
            threshold: 0.3
          }
        }"
      ></div>
    </div>
    <!-- Proiectul in imagini content -->
    <div class="subsection-wrapper" v-if="content.images.data.length > 0">
      <div class="shape shape--onlytitle"></div>
      <div class="project-start-img-content content active">
        <h3>{{ strings.de_la_schita }}</h3>
      </div>
    </div>

    <!-- single img left -->
    <div
      class="section-wrapper section-wrapper--lastsection"
      v-if="content.images.data.length > 0"
    >
      <div
        class="single-img mask-left"
        :class="{ active: maskR5 }"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'maskR5'),
          intersection: {
            threshold: 0.3
          }
        }"
      >
        <VueSlickCarousel v-bind="settings2" ref="carousel2">
          <div v-for="(img, index) in content.images.data" :key="index">
            <img :src="img.url[3].original" alt="" />
            <span class="gallery-fullscreen-ico" @click="showPhotoSwipe(index)">
              <svg
                width="30"
                height="30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  r="15"
                  transform="matrix(-1 0 0 1 15 15)"
                  fill="#FEFEFE"
                />
                <path
                  d="M22.4665 6.626a.593.593 0 01.593.593v5.3372a.593.593 0 01-1.186 0V7.812h-4.7441a.593.593 0 010-1.186h5.3371zm-4.2022 3.9566l3.7829-3.7829.8386.8387-3.7829 3.7829-.8386-.8387z"
                  fill="#000"
                />
                <path
                  d="M18.4727 11.2129l3.993-3.9931"
                  stroke="#000"
                  stroke-width="1.186"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.3897 7.219a.593.593 0 01.593-.593h5.3372a.593.593 0 010 1.186H7.5757v4.7442a.593.593 0 01-1.186 0V7.219zm3.9566 4.2023l-3.783-3.783.8387-.8386 3.783 3.7829-.8387.8387z"
                  fill="#000"
                />
                <path
                  d="M10.9756 11.2129L6.9825 7.2198"
                  stroke="#000"
                  stroke-width="1.186"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.9827 23.2959a.593.593 0 01-.593-.5931v-5.3371a.593.593 0 011.186 0v4.7441H12.32a.593.593 0 010 1.1861H6.9827zm4.2023-3.9567l-3.783 3.783-.8386-.8387 3.7829-3.7829.8387.8386z"
                  fill="#000"
                />
                <path
                  d="M10.9756 18.709l-3.9931 3.9931"
                  stroke="#000"
                  stroke-width="1.186"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M23.0586 22.7028a.593.593 0 01-.5931.5931h-5.3371a.593.593 0 010-1.1861h4.7441v-4.7441a.593.593 0 011.1861 0v5.3371zm-3.9567-4.2022l3.783 3.7829-.8387.8387-3.7829-3.783.8386-.8386z"
                  fill="#000"
                />
                <path
                  d="M18.4707 18.709l3.9931 3.9931"
                  stroke="#000"
                  stroke-width="1.186"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </div>
        </VueSlickCarousel>
      </div>
    </div>
    <!--  content -->
    <div class="subsection-wrapper" v-if="content.images.data.length > 0">
      <div class="shape shape--carousel"></div>
      <div class="about-us-content content active slider2">
        <h3>
          <span
            @click="moveSlide('prev')"
            class="slider2-arrow slider2-fake-prev"
          ></span
          >{{ strings.la_dezvoltare
          }}<span
            @click="moveSlide('next')"
            class="slider2-arrow slider2-fake-next"
          ></span>
        </h3>
      </div>
    </div>

    <!-- map -->
    <div class="section-wrapper" style="margin-top: 80px;z-index:80;">
      <div class="project-details-shadow our-projects-shadow mask-left active">
        <h2 class="poz-proiecte">
          {{ strings.pozitionare_proiecte_map_title }}
        </h2>
      </div>
    </div>
    <div class="project-map" ref="mapcontainer"></div>

    <!-- photoswipe gallery -->
    <v-photoswipe-gallery
      :isOpen="isOpenGallery"
      :options="optionsGallery"
      :items="fullscreenGalleryMobile"
      style="display: none;"
    >
      <!-- <img slot-scope="props" :src="props.item.src" alt="picture" /> -->
    </v-photoswipe-gallery>

    <v-photoswipe
      :isOpen="isOpen"
      :items="fullscreenGalleryMobile"
      :options="options"
      @close="hidePhotoSwipe"
    ></v-photoswipe>

    <!-- footer social -->
    <div class="social-footer">
      <div class="social-footer-wrapper">
        <div class="social-footer-network">
          <a :href="fbUrl" target="_blank" class="icon fb">
            <svg
              width="64"
              height="34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="59.2"
                height="24.9"
                rx="12.5"
                transform="rotate(8.1 .2 31.5)"
                fill="#F9DF41"
              />
              <path
                d="M28 32.5h6.5V16.3H39l.4-5.5h-4.9v-3c0-1.4.3-2 1.6-2h3.5V.4H35c-4.8 0-7 2-7 6.1v4.4h-3.4v5.5h3.4v16.2H28z"
                fill="#222221"
              />
            </svg>
          </a>
          <a :href="igUrl" target="_blank" class="icon ig"
            ><svg
              width="63"
              height="34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="59.2"
                height="24.9"
                rx="12.5"
                transform="rotate(8.1 0 27.5)"
                fill="#F9DF41"
              />
              <path
                d="M31.2 5.7c4 0 4.3 0 5.9.2a5 5 0 012.6.5c.7.3 1.1.6 1.7 1.2.6.5.8 1 1.1 1.6.2.6.4 1.3.6 2.7l.1 5.9-.1 5.9a5 5 0 01-.6 2.6c-.3.7-.5 1.2-1 1.7-.7.6-1 .9-1.8 1.1-.5.2-1.2.5-2.6.6l-6 .1-5.8-.1a5 5 0 01-2.7-.6c-.7-.2-1-.5-1.6-1-.6-.6-.9-1-1.2-1.8-.1-.5-.4-1.2-.5-2.6-.2-1.6-.2-2-.2-6 0-3.8 0-4.3.2-5.8a5 5 0 01.5-2.7c.3-.7.6-1 1.2-1.6.5-.6 1-.9 1.6-1.2.6-.1 1.3-.4 2.7-.5 1.4-.2 2-.2 5.9-.2zm0-2.6l-6 .1c-1.6.2-2.7.3-3.5.7-1 .4-1.9.9-2.6 1.7-.8.8-1.2 1.7-1.6 2.5-.5 1-.6 2-.7 3.5-.2 1.6-.2 2.1-.2 6 0 4 0 4.5.2 6 0 1.6.2 2.7.7 3.6.4 1 .8 1.8 1.6 2.5.9.8 1.7 1.3 2.6 1.7 1 .4 2 .5 3.5.7l6 .1 6-.1c1.5-.2 2.7-.3 3.5-.7 1-.4 1.8-.9 2.5-1.7.9-.8 1.3-1.7 1.7-2.5.4-1 .6-2 .7-3.5.2-1.6.2-2.1.2-6 0-4 0-4.5-.2-6C45.5 10 45.3 9 45 8c-.4-1-.8-1.8-1.7-2.5a8.8 8.8 0 00-2.5-1.7c-1-.4-2-.5-3.5-.7l-6-.1z"
                fill="#222221"
              />
              <path
                d="M31.2 10.2a7.5 7.5 0 00-7.6 7.6c0 4.2 3.4 7.6 7.6 7.6 4.2 0 7.5-3.4 7.5-7.6a7.7 7.7 0 00-7.5-7.6zm0 12.5a5 5 0 01-5-5 5 5 0 015-4.8 5 5 0 014.9 4.9c-.2 2.7-2.3 4.9-5 4.9zM40.7 10c0 1-.8 1.8-1.8 1.8S37 10.9 37 9.9c0-1 .8-1.8 1.8-1.8 1 .2 1.8.9 1.8 1.8z"
                fill="#222221"
              /></svg
          ></a>
          <a :href="liUrl" target="_blank" class="icon in">
            <svg
              width="63"
              height="34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="59.2"
                height="24.9"
                rx="12.5"
                transform="rotate(8.1 .2 30.7)"
                fill="#F9DF41"
              />
              <path fill="#000" d="M14.9 10.2h7.4v22.7h-7.4z" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M33.9 19.7c.5-1.6 2-3.7 4.4-3.7 2.3 0 3.5 2.3 3.5 3.4h7.4c0-1.9-.5-6-4-8.3-1.4-1-5.3-2.3-8.8 0-.8.6-1.8 1.7-2.5 3v-4h-7.4V33h7.4V19.7zm7.9-.3h7.4V33h-7.4V19.4z"
                fill="#000"
              />
              <ellipse cx="18.9" cy="3.7" rx="3.9" ry="3.7" fill="#000" />
            </svg>
          </a>
        </div>
        <span
          ><router-link v-bind:to="'/privacypolicy'">{{
            strings.privacy_title
          }}</router-link></span
        >
        <span>{{ strings.all_rights_reserved }}</span>
      </div>
      <!-- scroll to top -->
      <div class="scroll-to-top">
        <a href="#" @click.prevent="scrollTo('.project-hero')">
          <svg
            width="24"
            height="34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 1c-.5-.6-1.5-.6-2 0l-9.6 9.5a1.5 1.5 0 102.1 2.1L12 4.1l8.5 8.5a1.5 1.5 0 102.1-2.1L13.1.9zm.5 33V2h-3v32h3z"
              fill="#000"
            />
          </svg>
        </a>
      </div>
    </div>

    <!-- -->
  </div>
</template>

<script>
import axios from "axios";
import smoothscroll from "smoothscroll-polyfill";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import gmapsInit from "../utils/gmaps";
import router from "../router";
import { bus } from "../main";
import dateFormat from "dateformat";
import { PhotoSwipe, PhotoSwipeGallery } from "v-photoswipe";
import { ModelFbx } from 'vue-3d-model';

// kick off the polyfill!
smoothscroll.polyfill();

export default {
  name: "Project3d",
  components: {
    ModelFbx,
    VueSlickCarousel,
    "v-photoswipe": PhotoSwipe,
    "v-photoswipe-gallery": PhotoSwipeGallery
  },
  data() {
    return {
      isOpen: false,
      isOpenGallery: false,
      options: {
        index: 0,
        fullscreenEl: false,
        shareEl: true,
        captionEl: false,
        zoomEl: true,
        shareButtons: [
          {
            id: "download",
            label: "Download image",
            url: "{{raw_image_url}}",
            download: true
          }
        ]
      },
      optionsGallery: {
        zoomEl: true
      },
      fullscreenGalleryMobile: [
        {
          src:
            "https://farm4.staticflickr.com/3894/15008518202_c265dfa55f_h.jpg",
          w: 1600,
          h: 1600
        }
      ],
      viewportW: window.matchMedia("(max-width: 1024px)").matches ? 400 : 1000,
      viewportH: window.matchMedia("(max-width: 1024px)").matches ? 300 : 600,
      enablePan: true,
      enableZoom: true,
      enableRotate: true,
      screenSpacePanning: false,
      cameraposition: {
        x: 0,
        y: 0,
        z: 0
      },
      rotation: {
                x: 0,
                y: 0,
                z: 0
            },
      locale: "",
      form_type: "",
      user_name: "",
      user_email: "",
      user_phone: "",
      user_date: "",
      user_message: "",
      isMobile: false,
      isMaterialeVisible: false,
      isApartPosActive: false,
      apartDetailsH: null,
      maskR1: false,
      maskR2: false,
      maskR3: false,
      maskR4: false,
      maskR5: false,
      duration: 2,
      scaleClass: false,
      settings: {
        dots: false,
        arrows: true,
        dotsClass: "slick-dots custom-dot-class",
        edgeFriction: 0.35,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
      },
      settings2: {
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: false,
        pauseOnHover: false,
        edgeFriction: 0.35,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
      },
      settings3: {
        dots: false,
        arrows: true,
        infinite: false,
        edgeFriction: 0.35,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
      },
      sliderText1: {
        0: "Confort și finisaje",
        1: "Structură și finisaje",
        active: "Confort și finisaje"
      },
      sliderText: {
        0: "interioare",
        1: "exterioare",
        active: "interioare"
      },
      strings: {
        programeaza_intalnire_cta: "",
        programeaza_intalnire_headline: "",
        programeaza_intalnire_thanks: "",
        brosura_headline: "",
        apartamente: "",
        parcare: "",
        boxe: "",
        construiti: "",
        gradina: "",
        aproape_de_tot: "",
        vezi_materiale: "",
        lista_completa: "",
        tipuri_apartamente: "",
        tip_apartament: "",
        orientare: "",
        suprafata_utila: "",
        nivel: "",
        pozitionare_apartament: "",
        tabel_apt: "",
        tabel_nivel: "",
        tabel_curte: "",
        tabel_terasa: "",
        tabel_utili: "",
        tabel_camere: "",
        tabel_dormitoare: "",
        tabel_bai: "",
        tabel_disponibilitate: "",
        vezi_toate_planurile: "",
        proiectul_in_imagini: "",
        de_la_schita: "",
        la_dezvoltare: "",
        pozitionare_proiecte_map_title: "",
        all_rights_reserved: "",
        vezi_evolutia: ""
      },
      zona_impanzita: {},
      content: {
        name: "",
        year: "",
        status: "",
        address: "",
        title: "",
        subtitle: "",
        shortDescription: "",
        secondSubtitle: "",
        description: "",
        brochureUrl: ""
      },
      apartamente: [],
      fbUrl: "",
      igUrl: "",
      liUrl: ""
    };
  },
  methods: {
    fetchData: function() {
      var self = this;

      // console.log("locale is: " + self.locale);
      // reset strings
      self.strings.programeaza_intalnire_cta = "";
      self.strings.programeaza_intalnire_headline = "";
      self.strings.programeaza_intalnire_thanks = "";
      self.strings.brosura_headline = "";
      self.strings.apartamente = "";
      self.strings.parcare = "";
      self.strings.boxe = "";
      self.strings.construiti = "";
      self.strings.gradina = "";
      self.strings.aproape_de_tot = "";
      self.strings.vezi_materiale = "";
      self.strings.lista_completa = "";
      self.strings.tipuri_apartamente = "";
      self.strings.tip_apartament = "";
      self.strings.orientare = "";
      self.strings.suprafata_utila = "";
      self.strings.nivel = "";
      self.strings.pozitionare_apartament = "";
      self.strings.tabel_apt = "";
      self.strings.tabel_curte = "";
      self.strings.tabel_terasa = "";
      self.strings.tabel_utili = "";
      self.strings.tabel_camere = "";
      self.strings.tabel_dormitoare = "";
      self.strings.tabel_bai = "";
      self.strings.tabel_disponibilitate = "";
      self.strings.vezi_toate_planurile = "";
      self.strings.proiectul_in_imagini = "";
      self.strings.de_la_schita = "";
      self.strings.la_dezvoltare = "";
      self.strings.pozitionare_proiecte_map_title = "";
      self.strings.all_rights_reserved = "";

      // content
      axios
        .get(
          "https://api.riseapart.com/project" +
            "?slug=" +
            this.$route.params.slug,
          {
            headers: {
              "X-Locale": self.locale
            }
          }
        )
        .then(function(data) {
          self.content = data.data.data[0];
          // console.log("content: ", self.locale, self.content);

          // console.log(self.content.apartments.data[0].mediaFiles.level_6);

          // apartamente
          self.apartamente = self.content.apartments.data;

          // brosura
          self.content.brochureUrl = self.content.mediaFiles.brochure;
          // console.log(self.content.brochureUrl);

          //
          let x;
          for (x = 0; x < self.apartamente.length; x++) {
            self.apartamente[x].nameFull = self.apartamente[x].name.split("-");

            if (self.apartamente[x].nameFull.length > 2) {
              self.apartamente[x].nume =
                self.apartamente[x].nameFull[0] +
                "-" +
                self.apartamente[x].nameFull[1];
            } else {
              self.apartamente[x].nume = self.apartamente[x].nameFull[0];
            }

            self.apartamente[x].etaj =
              self.apartamente[x].nameFull[
                self.apartamente[x].nameFull.length - 1
              ];
          }

          if (self.content.zone) {
            self.zona_impanzita[0] = self.content.zone.split("|")[0];
            self.zona_impanzita[1] = self.content.zone.split("|")[1];
          }

          // poze galerie
          if (self.content.images.data) {
            self.fullscreenGalleryMobile = [];

            for (let y = 0; y < self.content.images.data.length; y++) {
              self.fullscreenGalleryMobile.push({
                src: self.content.images.data[y].url[3].original,
                w: 1600,
                h: 1600
              });
            }
          }

          //
          self.getHeight();

          //
          self.initMaps();
        })
        .catch(function(error) {
          console.log("Error", error);
        });

      // get translatable strings
      axios
        .get("https://api.riseapart.com/content?_limit=100", {
          headers: { "X-Locale": self.locale }
        })
        .then(function(data) {
          let stringsObj = data.data.data;
          let x;

          for (x = 0; x < stringsObj.length; x++) {
            let newObj = stringsObj[x];
            let newKey = Object.keys(newObj);
            self.strings[newObj[newKey].key] = newObj[newKey].value;

            //
            self.sliderText[0] = self.strings.interioare;
            self.sliderText[1] = self.strings.exterioare;
            self.sliderText.active = self.strings.interioare;
            //
            self.sliderText1[0] = self.strings.confort_si_finisaje;
            self.sliderText1[1] = self.strings.structura_si_finisaje;
            self.sliderText1.active = self.strings.confort_si_finisaje;
          }

          // check brochure headline
          if (localStorage.getItem("brochureDownloaded") === "true") {
            self.strings.brosura_headline =
              self.strings.brosure_headline_alreadydownloaded;
          }

          // console.log("strings: ", self.locale, self.strings);
        })
        .catch(function(error) {
          console.log("Error", error);
        });

      // get settings (social urls)
      axios
        .get("https://api.riseapart.com/configuration")
        .then(function(res) {
          var facebookUrl = res.data.data.filter(obj => {
            return obj.key === "FACEBOOK_URL";
          });

          var instagramUrl = res.data.data.filter(obj => {
            return obj.key === "INSTAGRAM_URL";
          });

          var linkedinUrl = res.data.data.filter(obj => {
            return obj.key === "LINKEDIN_URL";
          });

          self.fbUrl = facebookUrl[0].defaultValue;
          self.igUrl = instagramUrl[0].defaultValue;
          self.liUrl = linkedinUrl[0].defaultValue;
        })
        .catch(function(error) {
          console.log("Error", error);
        });
    },
    AppointmentForm(bool) {
      const el = document.querySelector(".appointment-form");
      if (bool) {
        document.querySelector("#date").value = dateFormat(
          new Date(),
          "yyyy-mm-dd"
        );
        el.classList.add("visible");
      } else {
        el.classList.remove("visible");
      }
    },
    DownloadForm(bool) {
      const el = document.querySelector(".download-form");
      if (bool) {
        el.classList.add("visible");
      } else {
        el.classList.remove("visible");
      }
    },
    StepIn(bool) {
      const el = document.querySelector(".step-in-view");
      if (bool) {
        el.classList.add("visible");
      } else {
        el.classList.remove("visible");
      }
    },
    forceDownloadFile(brochureUrl) {
      var self = this;
      axios({
        method: "get",
        url: brochureUrl,
        responseType: "arraybuffer"
      })
        .then(response => {
          console.log(response);

          // const url = window.URL.createObjectURL(
          //   new Blob([response.data], { type: "application/pdf" })
          // );
          const link = document.createElement("a");
          link.target = "_blank";
          link.href = brochureUrl;
          link.setAttribute("download", "RiseApart-BrosuraPrecupetiiVechi.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();

          // set local storage
          localStorage.setItem("brochureDownloaded", "true");

          // close form
          self.DownloadForm(false);
        })
        .catch(() => console.log("error occured"));
    },
    submitForm(e) {
      e.preventDefault();

      // console.log(e);
      var form = e.srcElement;
      var form_type = form.querySelector("#form_type").value;

      let bodyFormData = new FormData();
      bodyFormData.set("project", this.content.id);
      bodyFormData.set("type", form_type);
      bodyFormData.set("email", this.user_email);
      bodyFormData.set("name", this.user_name);
      bodyFormData.set("phone", this.user_phone);
      bodyFormData.set("message", this.user_message);
      bodyFormData.set("date", dateFormat(this.user_date, "dd-mm-yyyy"));
      bodyFormData.set("tos", "true");

      // set loading animation on button
      form.querySelector('input[type="submit"]').classList.add("loading");

      if (
        document.querySelector("#subscribe_newsletter") ||
        document.querySelector("#subscribe_newsletter").checked
      ) {
        bodyFormData.set("news", true);
      }

      var self = this;

      // important to force new window on mobile.
      if (self.isMobile) {
        var importantStuff = window.open("", "_blank");
      }

      axios({
        method: "post",
        url: "https://api.riseapart.com/send-form",
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" }
      })
        .then(function(response) {
          // stop loading animation
          form
            .querySelector('input[type="submit"]')
            .classList.remove("loading");

          // handle success
          // meeting
          if (response.data.data.sent === 1 && form_type === "meeting") {
            // thank you message
            form.parentElement.querySelector("h5").style.display = "none";
            form.style.display = "none";
            form.parentElement.querySelector("h6").style.display = "block";
          }

          // brochure
          if (response.data.data.sent === 1 && form_type === "brochure") {
            const brochureUrl = response.data.data.brochure;

            // start download
            if (brochureUrl) {
              if (self.isMobile) {
                // self.forceDownloadFile(brochureUrl);
                // window.open(brochureUrl);
                // update on forcing new window to open on mobile.
                importantStuff.location.href = brochureUrl;
              } else {
                const link = document.createElement("a");
                link.href = brochureUrl;
                link.target = "_blank";
                link.setAttribute(
                  "download",
                  "RiseApart-BrosuraPrecupetiiVechi.pdf"
                ); //or any other extension
                document.body.appendChild(link);

                //
                setTimeout(function() {
                  link.click();
                }, 1000);
                // close form
                self.DownloadForm(false);
              }
              //
            } else {
              // thank you message
            }
          }
        })
        .catch(function(response) {
          // stop loading animation
          form
            .querySelector('input[type="submit"]')
            .classList.remove("loading");

          //handle error
          // console.log("error: " + response);

          if (response.name) {
            form
              .querySelector("input[name='user_name']")
              .classList.add("error");
          }

          if (response.email) {
            form
              .querySelector("input[name='user_email']")
              .classList.add("error");
          }

          if (response.phone) {
            form
              .querySelector("input[name='user_phone']")
              .classList.add("error");
          }
        });
    },
    swipeIntExt(slideIndex) {
      this.sliderText.active = this.sliderText[slideIndex];
      this.sliderText1.active = this.sliderText1[slideIndex];
    },
    visibilityChanged(isVisible, entry, param) {
      if (isVisible && param === "numbers") {
        this.scaleClass = false;
        this.$refs.number1.restart();
        this.$refs.number2.restart();
        this.$refs.number3.restart();
        this.$refs.number4.restart();
        this.$refs.number5.restart();
      }

      // if visible
      if (isVisible) {
        if (param === "maskR1") {
          this.maskR1 = true;
        }

        if (param === "maskR2") {
          this.maskR2 = true;
        }

        if (param === "maskR3") {
          this.maskR3 = true;
        }

        if (param === "maskR4") {
          this.maskR4 = true;
        }

        if (param === "maskR5") {
          this.maskR5 = true;
        }
      }

      if (!isVisible) {
        if (param === "maskR1") {
          this.maskR1 = false;
        }

        if (param === "maskR2") {
          this.maskR2 = false;
        }

        if (param === "maskR3") {
          this.maskR3 = false;
        }

        if (param === "maskR4") {
          this.maskR4 = false;
        }

        if (param === "maskR5") {
          this.maskR5 = false;
        }
      }
    },
    scrollTo(el) {
      document.querySelector(el).scrollIntoView({
        behavior: "smooth"
      });
    },
    moveSlide(param) {
      if (param === "next") {
        this.$refs.carousel2.next();
      }
      if (param === "prev") {
        this.$refs.carousel2.prev();
      }
    },
    updateFakeArrows(slideIndex) {
      var allSlidesLength = document.querySelectorAll(
        ".section-wrapper--lastsection img"
      ).length;
      var prev = document.querySelector(".slider2-fake-prev");
      var next = document.querySelector(".slider2-fake-next");

      if (slideIndex === 0) {
        prev.classList.add("disabled");
      } else {
        prev.classList.remove("disabled");
      }

      if (slideIndex + 1 === allSlidesLength) {
        next.classList.add("disabled");
      } else {
        next.classList.remove("disabled");
      }
    },
    changeFloorPlan($event, index, id) {
      const wrapper = document.querySelector(
        ".apart-item[data-id='" + id + "']"
      );
      const slider = wrapper.querySelector(".apart-item-floorplan-wrapper");
      wrapper
        .querySelector(".apart-item-floors")
        .setAttribute("data-slide", index);
      slider.style.transform = "translate3d(" + (index - 1) * -100 + "%,0,0)";
    },
    toggleApartPos() {
      this.isApartPosActive = !this.isApartPosActive;
      this.getHeight();
    },
    toggleMaterialeList() {
      this.isMaterialeVisible = !this.isMaterialeVisible;
    },
    getHeight() {
      // todo: refactor
      // console.log("set h");
      setTimeout(
        function() {
          if (this.$refs.apartSlideWrapper) {
            const h = this.$refs.apartSlideWrapper.querySelector(
              ".slick-current"
            ).offsetHeight;
            this.$refs.apartSlideWrapper.style.height = h + 430 + "px";
          }
        }.bind(this),
        10
      );
    },
    beforeApartSlide() {
      if (this.$refs.apartSlideWrapper) {
        this.getHeight();
      }
    },
    mq() {
      this.isMobile = window.matchMedia("(max-width: 1024px)").matches;
    },
    toggleVideo(bool) {
      var elem = document.querySelector(".fullscreen-video");
      if (bool) {
        document.querySelector(".mobile-video").classList.add("show");
        document
          .querySelector(".video-controls")
          .setAttribute("data-playing", "true");
        elem.play();
      } else {
        // document.querySelector(".mobile-video").classList.remove("show");
        document
          .querySelector(".video-controls")
          .setAttribute("data-playing", "false");
        elem.pause();
      }
    },
    showPhotoSwipe(index) {
      this.isOpen = true;
      this.$set(this.options, "index", index);
    },
    hidePhotoSwipe() {
      this.isOpen = false;
    },
    setScrollPos() {
      var loaded = document.querySelector("html");
      if (
        this.$route.query.cta == "smart-home" &&
        !loaded.classList.contains("loaded")
      ) {
        document.querySelector(".apart-details").scrollIntoView({
          behavior: "auto"
        });
        loaded.classList.add("loaded");
      }
    },
    onModelLoad() {
      const el = document.querySelector(".viewer3d");
      el.classList.add("hide-loader");
    },
    async initMaps() {
      // gmaps
      try {
        const google = await gmapsInit();
        const precupeti = { lat: 44.44769, lng: 26.11796 };
        const ronda = { lat: 44.43691, lng: 26.12572 };
        const fainari = { lat: 44.44866, lng: 26.12109 };
        const center = { lat: 44.444722, lng: 26.120497 };

        //
        var map = new google.maps.Map(document.querySelector(".project-map"), {
          center: center,
          zoom: 15,
          styles: [
            {
              elementType: "geometry",
              stylers: [
                {
                  color: "#f5f5f5"
                }
              ]
            },
            {
              elementType: "labels.icon",
              stylers: [
                {
                  visibility: "off"
                }
              ]
            },
            {
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#616161"
                }
              ]
            },
            {
              elementType: "labels.text.stroke",
              stylers: [
                {
                  color: "#f5f5f5"
                }
              ]
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#bdbdbd"
                }
              ]
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [
                {
                  color: "#eeeeee"
                }
              ]
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#757575"
                }
              ]
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [
                {
                  color: "#e5e5e5"
                }
              ]
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#9e9e9e"
                }
              ]
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [
                {
                  color: "#ffffff"
                }
              ]
            },
            {
              featureType: "road.arterial",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#757575"
                }
              ]
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [
                {
                  color: "#dadada"
                }
              ]
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#616161"
                }
              ]
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#9e9e9e"
                }
              ]
            },
            {
              featureType: "transit.line",
              elementType: "geometry",
              stylers: [
                {
                  color: "#e5e5e5"
                }
              ]
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [
                {
                  color: "#eeeeee"
                }
              ]
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [
                {
                  color: "#c9c9c9"
                }
              ]
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#9e9e9e"
                }
              ]
            }
          ]
        });
        // The markers
        var markers = [];

        markers[0] = new google.maps.Marker({
          position: precupeti,
          url: "precupetii-vechi",
          icon: {
            url: require("../assets/precupetii-marker_" + this.locale + ".png"),
            size: new google.maps.Size(117, 168),
            scaledSize: new google.maps.Size(117, 168)
          },
          map: map
        });
        markers[1] = new google.maps.Marker({
          position: ronda,
          url: "ronda",
          icon: {
            url: require("../assets/ronda-marker_" + this.locale + ".png"),
            size: new google.maps.Size(117, 168),
            scaledSize: new google.maps.Size(117, 168)
          },
          map: map
        });
        markers[2] = new google.maps.Marker({
          position: fainari,
          url: "fainari",
          icon: {
            url: require("../assets/fainari-marker_" + this.locale + ".png"),
            size: new google.maps.Size(117, 168),
            scaledSize: new google.maps.Size(117, 168)
          },
          map: map
        });

        // set marker url
        for (var i = 0; i < markers.length; i++) {
          google.maps.event.addListener(markers[i], "click", function() {
            router.push({ path: `/project/${this.url}` });
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
  },
  updated: function() {
    // console.log(this.$route.query.stepin);
    //
    if (this.$route.query.stepin == "3d") {
      this.scrollTo('.apart-item-headline');
    }
    //
    // console.log("CTA: ", this.$route.query.cta);
    // console.log(document.querySelector(".smart-home-btn"));
    // if (this.$route.query.cta) {
    //   document.querySelector(".smart-home-btn").scrollIntoView({
    //     behavior: "smooth"
    //   });
    // }
    this.setScrollPos();
  },
  created() {
    // langCheck
    // console.log(this.$route.query.lang);
    if (!this.$route.query.lang) {
      router.push({ query: { lang: "ro" } });
      this.locale = "ro";
    } else {
      this.locale = this.$route.query.lang;
      this.fetchData();
    }

    // lang switch
    bus.$on("lang", data => {
      this.locale = data.lang;
      this.fetchData();
    });
    //
    // this.fetchData();
    //
    localStorage.setItem("loaded", "true");
    //
    this.$nextTick(function() {
      if (this.$refs.apartSlideWrapper) {
        this.getHeight();
      }
    });
    //
    this.$nextTick(function() {
      window.addEventListener("resize", this.mq);
      window.addEventListener("resize", this.getHeight);
    });
    this.mq();

    //
    // if (this.$route.query.cta == "smart-home") {
    //   document.querySelector(".smart-home").scrollIntoView({
    //     behavior: "smooth"
    //   });
    // }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.mq);
  },
  async mounted() {},
  computed: {},
  destroyed() {},
  watch: {
    "$route.params": {
      handler() {
        // this.fetchData(); // rm breaking nav consistency
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss">
@import "~@/assets/styles/_reset.scss";
@import "~@/assets/styles/_variables.scss";
@import "~@/assets/styles/_components.scss";
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600&display=swap");

html {
  &.loaded {
    scroll-behavior: smooth;
  }
}

.button-play-video {
  margin: 20px 0;
  z-index: 100;
}

.pswp__button--close,
.pswp__button--zoom {
  background-image: url("data:image/png;base64,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") !important;
}

.pswp__counter {
  color: $color-yellow !important;
}

.pswp__button--zoom {
  display: block !important;
}

.pswp__img {
  object-fit: contain;
}

.pswp__button--share {
  background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIzOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOTQuMDE0MyAxNzUuNzI5YzMuMzA1OCAzLjMwNiA4LjY2NTcgMy4zMDYgMTEuOTcxNyAwbDUzLjg3MS01My44NzFjMy4zMDYtMy4zMDYgMy4zMDYtOC42NjYgMC0xMS45NzItMy4zMDUtMy4zMDYtOC42NjUtMy4zMDYtMTEuOTcxIDBMMTAwIDE1Ny43NzJsLTQ3Ljg4NTktNDcuODg2Yy0zLjMwNTktMy4zMDYtOC42NjU3LTMuMzA2LTExLjk3MTUgMC0zLjMwNTggMy4zMDYtMy4zMDU4IDguNjY2IDAgMTEuOTcybDUzLjg3MTcgNTMuODcxek05MS41MzQ5IDguOTA2MlYxNjkuNzQzaDE2LjkzMDFWOC45MDYzSDkxLjUzNDl6IiBmaWxsPSIjRjlERjQxIi8+PHBhdGggZD0iTTEwMCA4LjkwNjNWMTY5Ljc0M005IDE2MS4yNzlWMjI5aDE4MnYtNjcuNzIxIiBzdHJva2U9IiNGOURGNDEiIHN0cm9rZS13aWR0aD0iMTYuOTMwMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+") !important;
  background-position: 50% 45% !important;
  background-size: 15px !important;
}

.gallery-fullscreen-ico {
  // display: none;
  position: absolute;
  top: 40px;
  left: 20px;
  display: block;
  width: 50px;
  height: 50px;

  svg {
    display: block;
    width: 230px;
    height: 230px;
    // transform: scale(0.15);
    fill: $color-light;
  }

  @media screen and (min-width: 768px) {
    position: absolute;
    top: 50px;
    left: 30px;
    display: block;
    width: 70px;
    height: 70px;
    transform: scale(1.1);
  }
}

.mobile-video {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100vh;
  background-color: $color-dark;
  z-index: -100;
  opacity: 0;

  &.show {
    // display: block;
    // z-index: 999;
    opacity: 1;

    .fullscreen-video {
      display: block;
    }
  }

  video {
    display: block;
    width: 100%;
    height: 100%;
  }

  @media screen and (min-width: 768px) {
    display: none;
  }
}

.video-controls {
  &[data-playing="true"] {
    .play {
      display: none;
    }

    .pause {
      display: block;
    }
  }

  &[data-playing="false"] {
    .pause {
      display: none;
    }

    .play {
      display: block;
    }
  }

  a {
    border: 0;
    background: none !important;
  }
}

.download {
  &-form {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 300;
    transform: translate3d(100vw, 0, 0);
    opacity: 0;
    transition: opacity 0.3s ease;

    &.visible {
      opacity: 1;
      transform: translate3d(0, 0, 0);

      .download-form-shape {
        transform: translate3d(0, 0, 0);

        @media screen and (max-width: 768px) {
          -webkit-mask-position: -100vw -40px;
          mask-position: -100vw -40px;
        }
      }
    }

    &-shape.mask-left {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: 100vw;
      height: 100vh;
      background: $color-yellow;
      -webkit-mask-position: 0 right;
      mask-position: 0 right;
      transform: translate3d(-200vw, -200px, 0);
      transition: transform 0.3s ease 0.4s;

      @media screen and (max-width: 768px) {
        flex-direction: column;
        padding: 60px 0;
        -webkit-mask-size: 1920px 940px;
        mask-size: 1920px 940px;
        -webkit-mask-position: 100vw 0;
        mask-position: 100vw 0;
        transition: -webkit-mask-position 0.4s ease 0.2s;
      }
    }

    &-col:nth-child(1) {
      margin: -100px 100px 0 0;

      @media screen and (max-width: 768px) {
        margin: 0 0 50px;
        transform: scale(0.7);
      }
    }

    &-col:nth-child(2) {
      margin: -50px 0 0 0;
    }

    &-col,
    form {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      max-width: 580px;

      h5 {
        display: block;
        width: 70%;
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: 300;
        font-size: 20px;
        line-height: 30px;
        color: $color-dark;
        text-align: left;

        @media screen and (max-width: 768px) {
          font-size: 14px;
          line-height: 24px;
        }

        span {
          display: block;
        }
      }
    }
  }
}

.step-in-view {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 300;
  transform: translate3d(100vw, 0, 0);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;

  &.visible {
    opacity: 1;
    transform: translate3d(0, 0, 0);
    pointer-events: auto;

    .step-in-view-shape {
      transform: translate3d(0, 0, 0);

      @media screen and (max-width: 768px) {
        -webkit-mask-position: -100vw -40px;
        mask-position: -100vw -40px;
      }
    }
  }

  &-shape.mask-left {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    background: $color-dark;
    -webkit-mask-position: 0 right;
    mask-position: 0 right;
    transform: translate3d(-200vw, -200px, 0);
    transition: transform 0.3s ease 0.4s;

    @media screen and (max-width: 768px) {
      flex-direction: column;
      padding: 60px 0;
      -webkit-mask-size: 1920px 940px;
      mask-size: 1920px 940px;
      -webkit-mask-position: 100vw 0;
      mask-position: 100vw 0;
      transition: -webkit-mask-position 0.4s ease 0.2s;

      a {
        position: absolute;
        top: 10vh;
        left: 60px;
      }
    }
  }

  .viewer3d {
    width: 360px;
    height: 60px;
    margin: 0;
    // background: url("../assets/loader.gif") center center no-repeat transparent;

    &::before {
      content: "step in.3d se incarca...";
      display: block;
      margin-top: 20px;
      font-size: 14px;
      color: white;
      text-align: center;
    }

    &.hide-loader {
      width: auto;
      height: auto;
      background: none;

      &::before {
        content: "step in.3d se incarca...";
        display: block;
        font-size: 0;
        color: $color-dark;
        text-align: center;
      }
    }
  }
}

.v-collapse-content {
  max-height: 0;
  transition: max-height 0.3s ease-out;
  overflow: hidden;
  padding: 0;
}

.v-collapse-content-end {
  transition: max-height 0.3s ease-in;
  max-height: 700px;

  @media screen and (max-width: 760px) {
  }
}

.section-wrapper {
  @media screen and (min-width: 1024px) {
    &--m0 {
      margin-top: 100px;
    }

    &--projectdetails {
      .project-details-mask {
        -webkit-mask-size: 120vw 110vh;
        mask-size: 120vw 110vh;
      }
    }
  }
  @media screen and (max-height: 850px) and (min-width: 1024px) {
    &:not(.section-wrapper--materials) {
      min-height: 900px;
    }

    &--projectdetails {
      z-index: 90;
    }
  }

  h2.poz-proiecte {
    margin-top: 120px;

    @media screen and (min-width: 1440px) {
      margin-top: 170px;
    }
  }

  &--projectdetails {
    margin-top: -234px;

    h2 {
      margin-top: 146px;
    }
  }

  &--materials {
    display: flex;
    flex-direction: column;
    height: auto !important;
    margin-top: 100px;
    text-align: center;

    .button {
      margin-top: 0 !important;

      &:not(.button--download) {
        svg {
          margin-left: 10px;
        }
      }
    }

    @media screen and (max-width: 760px) {
      // display: none;
      margin-top: 40px !important;
      margin-bottom: 100px;
    }
  }

  &--apartments {
    height: 100%;
    min-height: 100vh;

    @media screen and (max-width: 768px) {
      margin-bottom: -50px;
    }
  }

  &--lastsection {
    @media screen and (max-height: 850px) {
      + .subsection-wrapper {
        margin-top: -270px;
      }
    }

    @media screen and (max-width: 760px) {
      margin-top: 150px !important;

      + .subsection-wrapper {
        margin-top: 0;
      }
    }

    .slick-slider {
      .slick-slide {
        height: 100vh;

        div {
          height: 100%;
        }

        img {
          width: 100%;
          height: 100%;
          max-height: 100%;
          object-fit: cover;

          @media screen and (max-width: 760px) {
            max-width: 100%;
          }
        }
      }
    }
  }
}

.subsection-wrapper {
  &--table {
    display: block;
    width: 100vw;
    max-width: 1020px;
    margin: 40px auto 0;
    padding: 0 5vw;

    .table-scroll {
      width: 100%;
      overflow-y: scroll;
    }

    @media screen and (min-width: 1024px) {
      width: 84vw;
      max-width: 1020px;
      margin: 0 auto;
      padding: 0;
      overflow-y: hidden;

      .table-scroll {
        width: 100%;
        overflow-y: hidden;
      }
    }

    ol {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: 860px;
      padding-right: 5vw;

      @media screen and (min-width: 1024px) {
        width: 100%;
        padding-right: 0;
      }

      li {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        text-align: center;

        &.header {
          margin-bottom: 10px;

          span {
            font-weight: 600;
          }
        }

        &.item {
          margin-bottom: 10px;
        }

        &:not(.header) {
          span {
            &:first-child {
              position: relative;

              font-family: "Poppins", sans-serif;
              font-style: normal;
              font-weight: normal;
              font-size: 12px;
              line-height: 18px;
              text-align: center;
              text-transform: uppercase;
              color: $color-dark;

              &:after {
                content: "";
                position: absolute;
                top: -5px;
                left: 24px;
                width: 48px;
                height: 25px;
                border: 2px solid $color-yellow;
                border-radius: 14px;
                transform: rotate(12deg);

                @media screen and (max-width: 768px) {
                  top: -2px;
                  width: 38px;
                  height: 20px;
                  margin-right: 10px;
                  font-size: 10px;
                  line-height: 14px;
                }
              }

              @media screen and (max-width: 768px) {
                font-size: 12px;
                line-height: 18px;
              }
            }
          }
        }

        span {
          width: 10%;
          font-family: "Poppins", sans-serif;
          font-style: normal;
          font-weight: 300;
          font-size: 20px;
          line-height: 30px;
          text-align: center;
          color: $color-dark;

          &:last-child {
            width: 15%;
          }

          @media screen and (max-width: 768px) {
            font-size: 12px;
            line-height: 18px;
          }
        }
      }
    }

    .download-text {
      display: block;
      width: 100%;
      margin: 60px auto 0;
      text-align: center;
    }
  }
}

.project {
  width: 100vw;
  margin: 0 auto;

  .slider2 {
    h3 {
      position: relative;

      .slider2-arrow {
        position: absolute;
        top: 18px;
        width: 70px;
        height: 40px;
        z-index: 100;
        transition: opacity 0.3s ease;

        &:hover {
          cursor: pointer;
        }

        &.disabled {
          opacity: 0.6;
        }

        &::before {
          content: "";
          display: block;
          width: 71px;
          height: 16px;
          background: url("~@/assets/arrow.svg") 0 0 no-repeat transparent;

          @media screen and (max-width: 760px) {
            transform: scale(0.6);
          }
        }
      }

      .slider2-fake-prev {
        left: -50px;

        @media screen and (max-width: 760px) {
          top: 10px;
          left: -40px;
        }
      }

      .slider2-fake-next {
        right: -50px;

        @media screen and (max-width: 760px) {
          top: 10px;
          right: -40px;
        }

        &::before {
          transform: rotate(180deg);

          @media screen and (max-width: 760px) {
            transform: rotate(180deg) scale(0.6);
          }
        }
      }
    }
  }

  .shape {
    &--onlytitle {
      margin: -80px auto -180px;

      + .content {
        transform: translate3d(0, -70px, 0);
      }

      @media screen and (max-width: 760px) {
        margin-top: 60px !important;

        + .content h3 {
          margin-top: 180px;
          margin-bottom: -200px;
        }
      }
    }

    &--carousel {
      margin: -150px auto -180px;

      @media screen and (max-width: 760px) {
        margin: -150px auto -200px;
      }

      + .content {
        transform: translate3d(0, -70px, 0);
      }
    }
  }

  &-hero {
    position: relative;
    display: block;
    width: 100vw;
    height: 100vh;
    margin-top: 0;
    margin-left: 0;
    margin-bottom: -100px;
    background-color: $color-dark;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    -webkit-mask-position: -20vw -20px;
    mask-position: -20vw -20px;
    z-index: 90;
    pointer-events: none;

    video,
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &-details {
    display: block;
    width: 100vw;
    height: 100vh;
    margin-top: 30px;
    margin-left: 0;
    background-size: cover;
    background-position: center center;
    background-repeat: none;
    background-color: $color-light;
    text-align: center;
    transition: opacity 0.3s ease, -webkit-mask-position 1s ease;

    &-shadow {
      display: block;
      width: 100vw;
      height: 100vh;
      background-color: $color-dark;
    }

    &-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      max-width: calc(1200px - 100px);
      height: 100%;
      max-height: 620px;
      margin: 120px auto 0;
    }

    &-block {
      display: flex;
      flex-direction: column;
      align-items: center;

      &--row {
        width: 80%;
        margin-top: 80px;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;

        @media screen and (max-width: 760px) {
          width: 100%;
        }
      }

      &-title {
        display: block;
      }

      .v-spacer {
        display: block;
        width: 2px;
        height: 25px;
        margin: 25px auto;
        background: $color-dark;

        @media screen and (max-width: 760px) {
          height: 16px;
          margin: 16px auto;
        }
      }

      @media screen and (max-width: 760px) {
        flex-wrap: wrap;

        &-item {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          width: 33%;

          &:last-child {
            margin-right: auto;
          }
        }
      }

      h5,
      h6 {
        display: block;
        font-family: "Poppins", sans-serif;
        font-style: normal;
        color: $color-dark;
        text-align: center;
      }

      h5 {
        font-weight: normal;
        font-size: 18px;
        line-height: 27px;
        letter-spacing: 0.2em;
        text-transform: uppercase;
        color: $color-dark;

        @media screen and (max-width: 760px) {
          font-size: 12px;
        }
      }

      h6 {
        font-weight: 300;
        font-size: 20px;
        line-height: 28px;

        @media screen and (max-width: 760px) {
          margin: 0;
          font-size: 12px;
          line-height: 20px;
        }

        span {
          &:first-child {
            display: inline-block;
          }

          display: block;
        }
      }
    }
  }

  .single-img {
    display: block;
    width: 100vw;
    height: 100vh;
    margin-top: 30px;
    margin-left: 0;
    background-size: cover;
    background-position: center center;
    background-repeat: none;
    background-color: $color-light;
    text-align: center;

    &--four {
      background-image: url("~@/assets/content/section-4.jpg");
    }
  }

  .nearbydetails {
    display: block;
    margin-top: 110px;

    &-list {
      display: block;
      width: 53vw;
      max-width: 640px;
      margin: 0 auto;

      @media screen and (max-width: 760px) {
        width: 80vw;
      }
    }

    &-item {
      position: relative;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 80px;
      margin-bottom: 25px;

      &:last-child {
        margin-bottom: 0;
      }

      .text {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-left: 40px;

        span {
          display: block;
          width: calc(100% - 20px);
          padding: 0 30px 0 20px;
          margin-left: -20px;
          font-family: "Poppins", sans-serif;
          font-style: normal;
          font-weight: 300;
          font-size: 20px;
          text-align: center;
          color: $color-dark;

          @media screen and (max-width: 760px) {
            font-size: 12px;
          }

          &:first-child {
            padding-bottom: 5px;
            margin-bottom: 5px;
            border-bottom: 1px dotted $color-dark;
          }

          &:nth-child(2) {
            font-weight: 600;
          }
        }
      }

      &--foot,
      &--car {
        &::before,
        &::after {
          content: "";
          position: absolute;
          display: block;
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;

          @media screen and (max-width: 760px) {
            transform: scale(0.6);
            transform-origin: bottom center;
          }
        }

        &::after {
          top: -18px;
          right: 0;
          width: 43px;
          height: 60px;
          background-image: url("~@/assets/nearby-pin.svg");
        }
      }

      &--foot {
        &::before {
          top: -40px;
          left: 0;
          width: 50px;
          height: 80px;
          background-image: url("~@/assets/nearby-walk.svg");
        }
      }

      &--car {
        &::before {
          top: -10px;
          left: -24px;
          width: 96px;
          height: 50px;
          background-image: url("~@/assets/nearby-car.svg");
        }
      }

      &--final {
        flex-direction: column;
        height: auto;

        &::before {
          content: "";
          position: relative;
          display: block;
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;
          width: 160px;
          height: 76px;
          margin-bottom: 10px;
          background-image: url("~@/assets/nearby-locations.svg");
        }

        .text {
          span {
            &:first-child {
              padding-bottom: 0;
              margin-bottom: 0;
              border-bottom: 0;
            }
          }
        }
      }
    }
  }

  .int-ext {
    width: 100vw;
    height: 100vh;
    margin-top: 30px;
    margin-left: 0;
    background-color: $color-lightgrey;
    text-align: center;

    @media screen and (max-width: 760px) {
      height: calc(100% - 30px);
    }

    &-shadow {
      display: block;
      width: 100vw;
      height: 100vh;
      background-color: $color-yellow;

      @media screen and (max-width: 760px) {
        height: 100%;
      }

      h2 {
        color: $color-dark;

        span {
          display: block;
        }
      }
    }

    &-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      max-width: 1440px;
      height: 60%;
      margin: 0 auto 0;
    }

    .slick-slider {
      height: 60vh;
      margin-top: 110px;

      @media screen and (max-width: 760px) {
        height: 25vh;
      }
    }
  }

  .materials {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height: auto;
    width: 35vw;
    max-width: 545px;
    margin: 0 auto;

    @media screen and (max-width: 760px) {
      width: 60vw;
    }

    &-list {
      margin-top: 50px;
    }

    &-item,
    &-text {
      display: block;
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 300;
      font-size: 20px;
      line-height: 30px;
      text-align: center;
      color: $color-dark;

      @media screen and (max-width: 760px) {
        font-size: 12px;
        line-height: 20px;
      }
    }

    &-item {
      line-height: 50px;

      @media screen and (max-width: 760px) {
        line-height: 20px;
      }
    }

    &-text {
      margin-top: 50px;
      margin-bottom: 20px;
    }
  }

  .project-start-img {
    display: block;
    width: 100vw;
    height: 100vh;
    margin-top: 30px;
    margin-left: 0;
    background-image: url("~@/assets/content/section-2.jpg");
    background-size: cover;
    background-position: 0 45%;
    background-repeat: no-repeat;
    // background-attachment: fixed;
    background-color: $color-light;
    text-align: center;

    @media screen and (max-width: 768px) {
      background-size: cover;
      background-position: center center;
    }

    &-shadow {
      display: block;
      width: 100vw;
      height: 100vh;
      background-color: $color-yellow;

      h2 {
        color: $color-dark;
      }
    }

    &-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      max-width: 1440px;
      height: 60%;
      margin: 0 auto 0;
    }
  }

  .single-img {
    display: block;
    width: 100vw;
    height: 100vh;
    margin-top: 30px;
    margin-left: 0;
    background-size: cover;
    background-position: center center;
    background-repeat: none;
    background-color: $color-light;
    text-align: center;

    &--three {
      background-image: url("~@/assets/content/section-3.jpg");
    }

    &--four {
      background-image: url("~@/assets/content/section-4.jpg");
    }

    &--five {
      background-image: url("~@/assets/content/section-5.jpg");
    }
  }

  &-map {
    position: relative;
    display: block;
    width: 100vw;
    height: 100vh;
    margin-top: -75vh;
    z-index: 90;

    @media screen and (max-height: 850px) {
      margin-top: -90vh;
    }

    @media screen and (max-width: 760px) {
      margin-top: -75vh;
    }
  }
}

.apart {
  &-details {
    position: relative;
    display: block;
    width: 100%;
    margin-top: 40px;
    z-index: 79;

    .slick-slider {
      margin-top: 150px;

      .slick-prev,
      .slick-next {
        top: 14px;

        @media screen and (max-width: 768px) {
          top: 34px;
        }
      }

      .slick-prev {
        left: calc(40% - 180px);

        @media screen and (max-width: 768px) {
          left: 0;
        }
      }

      .slick-next {
        right: calc(40% - 180px);

        @media screen and (max-width: 768px) {
          right: 0;
        }
      }
    }
  }

  &-item {
    &-headline {
      h4 {
        display: block;
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 27px;
        text-align: center;
        letter-spacing: 0.2em;
        text-transform: uppercase;
        color: $color-dark;
        text-transform: uppercase;

        @media screen and (max-width: 768px) {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }

    &-subheadline {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      width: 50vw;
      max-width: 600px;
      margin: 50px auto 0;

      @media screen and (max-width: 768px) {
        flex-direction: column;
        align-items: center;
      }

      h5 {
        display: block;
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        align-items: center;
        text-align: center;
        color: $color-dark;

        span {
          display: block;
          font-weight: 300;
        }

        @media screen and (max-width: 768px) {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }

    &-floors {
      margin-top: -20px;
      text-align: center;

      @media screen and (max-width: 768px) {
        margin-top: 0;
      }

      &[data-slide="1"] {
        .button:first-child {
          background-color: $color-yellow;
        }
      }

      &[data-slide="2"] {
        .button:nth-child(2) {
          background-color: $color-yellow;
        }
      }

      &[data-slide="3"] {
        .button:nth-child(3) {
          background-color: $color-yellow;
        }
      }

      .button {
        margin-right: 14px;
        outline: none;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    &-floorplan {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: flex-start;
      width: 90vw;
      height: auto;
      margin: 90px auto 90px;

      &-left {
        width: 28vw;
        max-width: 400px;
      }

      &-right {
        display: block;
        width: 700px;
        height: 100%;
        overflow: hidden;
      }

      &-wrapper {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        width: 100%;
        transition: transform 0.3s ease;

        img {
          width: 100%;
          height: auto;
          object-fit: contain;
        }
      }

      @media screen and (max-width: 768px) {
        flex-direction: column;
        width: 100vw;
        font-size: 14px;
        line-height: 20px;

        &-left {
          order: 2;
          width: 65vw;
          margin: 40px auto 0;
        }

        &-right {
          order: 1;
          width: 100%;
        }

        &-wrapper {
          img {
            max-width: 100%;
          }
        }
      }
    }

    .rooms-list {
      display: block;

      &-item {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        margin-bottom: 20px;

        &:last-child {
          .room-ico {
            opacity: 0;
            visibility: hidden;
          }
        }

        &:last-child {
          margin-bottom: 0;
        }

        .room {
          &-ico {
            position: relative;
            width: 48px;
            height: 25px;
            margin-right: 18px;
            font-family: "Poppins", sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 18px;
            text-align: center;
            text-transform: uppercase;
            color: $color-dark;

            &:after {
              content: "";
              position: absolute;
              top: -5px;
              left: -2px;
              width: 100%;
              height: 100%;
              border: 2px solid $color-yellow;
              border-radius: 14px;
              transform: rotate(12deg);
            }

            @media screen and (max-width: 768px) {
              width: 38px;
              height: 20px;
              margin-right: 10px;
              font-size: 10px;
              line-height: 14px;
            }
          }

          &-title,
          &-sqm {
            display: block;
            font-family: "Poppins", sans-serif;
            font-style: normal;
            font-weight: 300;
            font-size: 20px;
            line-height: 30px;
            color: $color-dark;

            @media screen and (max-width: 768px) {
              font-size: 12px;
              line-height: 18px;
            }
          }

          &-sqm {
            width: 20%;
            text-align: right;
          }

          &-title {
            width: calc(80% - 48px);
            margin-right: 18px;
            text-align: left;

            @media screen and (max-width: 768px) {
              margin-right: 8px;
            }
          }
        }
      }
    }

    &-pos {
      display: block;
      width: 90vw;
      height: 62px;
      max-height: 732px;
      margin: 0 auto;
      text-align: center;
      overflow: hidden;

      .button {
        min-width: 240px;
        margin-top: 0;

        svg {
          margin-left: 10px;
        }
      }

      &.visible {
        height: 572px;
      }

      img {
        display: block;
        margin-top: 90px;
        width: 100%;
        max-height: 400px !important;
        object-fit: contain !important;
        pointer-events: none;
      }

      @media screen and (max-width: 768px) {
        height: 42px;
        margin-right: 8px;

        &.visible {
          height: 460px;
        }

        img {
          max-height: 290px !important;
          object-fit: contain;
        }
      }
    }
  }
}

@media screen and (max-width: 760px) {
  .project {
    &-hero {
      margin-bottom: 0;
      background-image: url("~@/assets/content/hero-m.gif");
      background-size: cover;
      background-position: center center;
      background-repeat: none;

      video {
        display: none;
      }

      &.mask-right {
        -webkit-mask-position: right -20vh;
        mask-position: right -20vh;
      }

      &-content {
        h3,
        h2 {
          width: 80vw;
        }

        h3 {
          font-family: "Poppins", sans-serif;
          font-style: normal;
          font-weight: 600;
          font-size: 10px;
          line-height: 15px;
          letter-spacing: 0.2em;
        }

        h2 {
          font-family: "gopherbold";
          font-style: normal;
          font-size: 35px;
          line-height: 35px;
          text-align: center;
        }

        a {
          padding: 13px 11px;
          font-size: 10px;
          line-height: 12px;
          border-radius: 44px;
        }
      }
    }

    .section-wrapper {
      height: calc(100vh - 65px);
      margin-top: -48px;
      z-index: 90;

      > div:not(.social-footer) + div {
        // top: -100px;
        top: 0;
      }

      &--m0 {
        margin-top: 120px;
      }

      &--projects {
        height: 960px;

        .button--map {
          display: none;
        }
      }

      &--footer {
        height: 940px;
      }

      @media screen and (max-width: 1024px) {
        &--int-ext {
          height: 55vh;
        }
      }

      &.mt190 {
        margin-top: -90px;
      }

      &.mt120 {
        margin-top: -100px;
      }

      h2 {
        margin: 50px auto 0;
        font-size: 12px;
        line-height: 18px;
      }

      .single-img {
        height: calc(100vh - 65px);
      }
    }

    .our-projects {
      height: 150vh;

      &.mask-right {
        -webkit-mask-size: 1920px 1100px;
        mask-size: 1920px 1100px;
      }

      &-wrapper {
        flex-direction: column;
        height: auto;
        padding-top: 90px;

        @media screen and (max-width: 760px) {
          padding-top: 0;
        }
      }

      &-block {
        margin-top: -30px;

        &:nth-child(2) {
          margin-top: -30px;

          .our-projects-block-title {
            margin-top: -80px;
          }
        }

        &:nth-child(3) {
          margin-top: -30px;

          .our-projects-block-title {
            margin-top: -70px;
          }
        }

        &-title {
          margin-top: -60px;
          padding: 10px 30px;

          span {
            font-size: 10px;
          }
        }

        h4 {
          font-size: 20px;
        }

        svg {
          transform: scale(0.4);
        }
      }
    }

    .about-us {
      background-position: center 0;

      &-shadow {
        height: 89vh;
      }

      &-content {
        margin-top: 200px;

        &.mt180 {
          margin-top: 180px;
        }
      }
    }

    .subsection-wrapper {
      margin-bottom: 60px;

      .shape {
        width: 73vw;
        height: 120px;
        margin-top: 0;
        border-radius: 64px;

        &--withtitle {
          margin-top: 40px;
        }

        &--notitle {
          margin-top: 170px;
        }

        &.short {
          margin: -20px auto -150px;
        }
      }

      h3 {
        width: 66vw;
        font-size: 24px;
        line-height: 30px;
      }

      p {
        width: 66vw;
        max-width: 66vw;
        font-size: 12px;
        line-height: 18px;
      }
    }

    .footer {
      height: 1000px;
    }

    .footer-wrapper {
      flex-direction: column;
      margin-top: 120px;

      &-text {
        width: 80vw;
        margin: 0 auto;

        h4 {
          width: 70%;
          margin: 0 auto;
          font-size: 23px;
          line-height: 29px;
          text-align: center;
        }

        p {
          font-size: 12px;
          line-height: 18px;
          text-align: justify;
        }
      }

      &-form {
        width: 80vw;
        margin: 0 auto;

        h5 {
          display: block;
          width: 100%;
          font-size: 15px;
          text-align: center;
        }
      }
    }

    .social-footer {
      margin: 20px auto;
    }
  }
}
</style>
